export default {
  /* - Menu - */
  section_title_dashboard: 'Panel',
  section_title_users: 'Usuarios',
  section_title_transactions: 'Transacciones',
  section_title_customers: 'Clientes',
  section_title_office_users_list: 'Usuarios',
  section_title_active_users: 'Usuarios',
  section_title_archived_users: 'Usuarios',
  section_title_superadmin_users: 'Usuarios',
  section_title_active_customers: 'Clientes',
  section_title_transactions_charged: 'Transacciones',
  section_title_transactions_declined: 'Transacciones',
  section_title_transactions_authorizations: 'Transacciones',
  section_title_transactions_history: 'Transacciones',
  section_title_transactions_alternate_label: 'Transacciones del equipo',
  section_title_reimbursements_alternate_label: 'Gastos del equipo',
  section_title_budgets: 'Presupuestos',
  section_title_budget_expense_evolution: 'Presupuestos',
  section_title_budgets_reimbursements: 'Presupuestos',
  section_title_budgets_active: 'Presupuestos',
  section_title_budgets_archived: 'Presupuestos',
  section_title_budget_members: 'Presupuestos',
  section_title_export_settings: 'Ajustes de exportación',
  section_title_export: 'Exportación',
  section_title_export_create: 'Exportación',
  section_title_export_table_transactions: 'Exportación',
  section_title_export_table_expenses: 'Exportación',
  section_title_export_table_all: 'Exportación',
  section_title_export_exported: 'Exportación',
  section_title_user_profile_detail: 'Perfil',
  section_title_user_preferences: 'Preferencias',
  section_title_user_overview: 'Resumen',
  section_title_user_cards: 'Usuarios',
  section_title_user_transactions: 'Usuarios',
  section_title_user_budgets: 'Usuarios',
  section_title_user_benefits: 'Usuarios',
  section_title_user_reimbursements: 'Usuarios',
  section_title_superadmin_massive_import_details: 'Subida masiva de usuarios',
  section_title_cards: 'Tarjetas',
  section_title_budget_cards: 'Tarjetas',
  section_title_virtual_cards: 'Tarjetas',
  section_title_physical_cards: 'Tarjetas',
  section_title_budgets_transactions: 'Presupuestos',
  section_title_transactions_pending: 'Transacciones',
  section_title_logs: 'Logs',
  section_title_office_log: 'Logs',
  section_title_cards_log: 'Logs',
  section_title_user_log: 'Logs',
  section_title_webhook_log: 'Logs',
  section_title_company: 'Ajustes',
  section_title_company_details: 'Ajustes',
  section_title_transaction_fields: 'Ajustes',
  section_title_expense_fields: 'Ajustes',
  section_title_integrations: 'Ajustes',
  section_title_integration_detail: 'Ajustes',
  section_title_profile: 'Perfil',
  section_title_benefits: 'Beneficios',
  section_title_benefits_users: 'Beneficios',
  section_title_benefit_transactions: 'Beneficios',
  section_title_social_benefits: 'Beneficios',
  section_title_merchants_settings: 'Configuración de comercios',
  section_title_activity_group_settings: 'Configuración de comercios',
  section_title_reimbursements: 'Gastos',
  section_title_reimbursements_pending: 'Gastos',
  section_title_reimbursements_history: 'Gastos',
  section_title_expenses: 'Mis gastos',
  section_title_my_virtual_cards: 'Mis tarjetas',
  section_title_my_physical_cards: 'Mis tarjetas',
  section_title_my_history_reimbursements: 'Mis gastos',
  section_title_my_history_reimbursements_breadcrumb: 'Historial de gastos',
  section_title_my_charged_transactions: 'Mis transacciones',
  section_title_my_charged_transactions_breadcrumb: 'Transacciones cargadas',
  section_title_my_authorizations_transactions: 'Mis transacciones',
  section_title_my_authorizations_transactions_breadcrumb: 'Autorizaciones',
  section_title_my_declined_transactions: 'Mis transacciones',
  section_title_my_declined_transactions_breadcrumb: 'Transacciones denegadas',
  section_title_my_pending_reimbursements: 'Mis gastos',
  section_title_my_pending_reimbursements_breadcrumb: 'Pendientes de revisión',
  section_title_my_transactions: 'Mis transacciones',
  section_title_all_cards: 'Tarjetas del equipo',

  section_title_my_reimbursements: 'Mis gastos',
  section_title_my_cards: 'Mis tarjetas',

  section_transaction_hover:
    'Aquí se muestran las transacciones del mes en curso',
  /* - Common Terms - */
  USERNAME: 'Introduce tu email de usuario',
  USERNAME_EMAIL: 'Email de usuario',

  EMAIL: 'Correo',
  EXPENSE_CENTER: 'Centro de gasto',
  EXPENSE_CENTER_PLACEHOLDER: 'Centro de gasto (opcional)',
  IDENTIFIER: 'Identificador',
  IDENTIFIER_PLACEHOLDER: 'Identificador (opcional)',
  WORK_EMAIL_PLACEHOLDER: 'Tu correo de trabajo',
  PASSWORD: 'Contraseña',
  PASSWORD_PLACEHOLDER: 'Crea una contraseña',
  REPEAT_PASSWORD: 'Repetir Contraseña',
  REPEAT_PASSWORD_PLACEHOLDER: 'Repite la contraseña',
  CURRENT_PASSWORD: 'Contraseña actual',
  NEW_PASSWORD: 'Nueva Contraseña',
  REPEAT_NEW_PASSWORD: 'Repite tu Nueva Contraseña',
  NAME: 'Nombre',
  NAME_PLACEHOLDER: 'Tu nombre',
  FIRST_NAME: 'Nombre',
  LAST_NAME: 'Apellidos',
  LAST_NAME_PLACEHOLDER: 'Tus apellidos',
  PHONE_NUMBER: 'Teléfono',
  MOBILE_PHONE_NUMBER: 'Teléfono Móvil',
  PHONE_PREFIX: 'Prefijo',
  PASSCODE: 'Clave',
  CITY: 'Ciudad',
  ADDRESS: 'Dirección',
  ADDRESS_PLACEHOLDER: 'Calle, número, piso, puerta...',
  ZIP: 'Código Postal',
  STATE: 'Provincia',
  ROLES: 'Rol',
  COUNTRY: 'País',
  USERS_KEYWORD: 'Usuarios',
  OTP: 'One Time Password',
  CURRENCY: 'Divisa',
  STATUS: 'Estado',
  USER: 'Usuario',
  DATE_OF_BIRTH: 'Fecha de nacimiento',
  BUDGETS: 'Presupuesto',
  MEMBERSHIP_STATUS: 'Membresía',
  ROLE_ADMIN: 'Administrador',
  ROLE_ADMIN_OWNER: 'Account holder',
  ROLE_ACCOUNT_HOLDER: 'Account holder',
  ROLE_BOOKKEEPER: 'Contable',
  ROLE_REGULAR: 'Normal',
  ROLE_COMMERCIAL: 'Comercial',
  ROLE_SUPER_BOOKKEEPER: 'Super contable',
  ROLE_BUDGET_OWNER: 'Dueño del presupuesto', // Fake role
  FORGOT_PASSWORD: 'Olvidé Mi Contraseña',
  FILTERS: 'Filtros',
  COLUMNS: 'Columnas',
  FILTER_FROM: 'Desde',
  FILTER_TO: 'Hasta',
  FILTER_AMOUNT_FROM: 'Cantidad desde',
  FILTER_AMOUNT_TO: 'Cantidad hasta',
  IMPERSONATE_BAR_TEXT:
    'Estás suplantando a : {userName} {userLastName} <email: {email}>',
  OFFICE_INFORMATION: 'Información de empresa',
  OFFICE_TOTAL_EMPLOYEES: 'Nº de empleados',
  OFFICE_USERS_TO_INVOICE: 'Nº mínimo a facturar',
  ACTION_IMPERSONATE_STOP: 'Detener Suplantación',
  ACTIONS_LABEL: 'Acciones',
  ACTION_EDIT: 'Editar',
  ACTION_SAVE: 'Guardar',
  ACTION_SAVE_CHANGES: 'Guardar cambios',
  ACTION_DELETE: 'Archivar',
  ACTION_REMOVE: 'Borrar',
  ACTION_REMOVE_ALT: 'Eliminar',
  ACTION_RESTORE: 'Restaurar',
  ACTION_CREATE: 'Crear',
  ACTION_CONTINUE: 'Continuar',
  ACTION_ASSIGN: 'Asignar',
  ACTION_ACCEPT: 'Aceptar',
  ACTION_REJECT: 'Rechazar',
  ACTION_SEND: 'Enviar',
  ACTION_SENDING: 'Enviando...',
  ACTION_UPDATE: 'Actualizar',
  ACTION_GO_BACK: 'Volver',
  ACTION_LOGIN: 'Iniciar sesión',
  ACTION_LOGOUT: 'Cerrar sesión',
  ACTION_LOAD_MORE: 'Cargar Más',
  ACTION_SEARCH: 'Buscar...',
  ACTION_CLEAR: 'Borrar',
  ACTION_FILTER: 'Filtrar',
  ACTION_CHECK: 'Ver...',
  ACTION_SIGN_UP: 'Regístrate',
  ACTION_SIGN_UP_ACCOUNT: 'Crear cuenta',
  ACTION_DOWNLOAD: 'Descargar',
  ACTION_EXPORT_IN_PROGRESS: 'Exportando...',
  ACTION_COPY_TO_CLIPBOARD: 'Copiado en el portapapeles',
  ACTION_CONFIRM: 'Confirmar',
  ACTION_CANCEL: 'Cancelar',
  ACTION_READ_MORE: 'leer más',
  ACTION_BILL_CLIENT: 'Hacer cobro',
  ACTION_CONTACT_US: 'Contáctanos',
  ACTION_RELOAD: 'Recargar página',
  ACTION_CLICK_HERE: 'Click aquí',
  ACTION_ADD_RECEIPT: 'Añadir recibo',
  ACTION_NEXT_STEP: 'Siguiente',
  ACTION_RETURN_TO_LOGIN: 'Volver a inicio de sesión',
  ACTION_REINVITE: 'Reenviar invitación',
  ACTION_REINVITING: 'Reenviando invitación',
  ACTION_ALSO_CLOSE: 'Cerrar igualmente',

  RET_FLEX_KEY: 'Retribución flexible',
  BENEFITS_KEY: 'Beneficios sociales',
  DEVOLUIVA_KEY: 'Devoluiva',

  MULTISELECT_DEFAULT_SELECT_LABEL: 'Seleccionar',
  MULTISELECT_DEFAULT_SELECTED_LABEL: 'Seleccionado',
  MULTISELECT_DEFAULT_DESELECT_LABEL: 'Quitar Selección',
  MULTISELECT_DEFAULT_NO_OPTIONS: 'No hay opciones disponibles',
  MULTISELECT_DEFAULT_NO_RESULTS: 'No se han encontrado resultados',
  MULTISELECT_OPTION_LABEL_ALL: 'Todos',
  MULTISELECT_OPTION_LABEL_RECENT: 'Usados recientemente',
  G_AUTOCOMPLETE_DEFAULT_PLACEHOLDER: 'Introduce país, ciudad o calle...',
  SUPPORT_EMAIL: 'customer.support@getfuell.com',
  OR_KEYWORD: 'O',
  ACTION_DOWNLOAD_APP: '¿Aún no tienes la App?',
  AND: 'y',

  ID: 'ID',
  /* ----- LOGIN ----- */
  login_welcome_fuell: 'Inicia sesión con tu cuenta',
  login_download_apps: 'Descarga las apps',
  /* - Snackabr Login Messages - */
  login_action_login_snackbar_error:
    '¡Ups! Algo ha ido mal al intentar inciar sesión ',
  login_action_accept_invitation_success:
    '¡Ya has acabado por aquí! Descárgate la app para poder empezar a operar con Fuell',
  login_action_accept_invitation_error:
    '¡Ups! Algo ha ido mal al intentar aceptar la invitación: ',
  login_action_request_reset_password_info:
    'Has pedido reiniciar tu contraseña, comprueba tu correo y sigue las instrucciones',
  login_action_request_reset_password_error:
    '¡Ups! Algo ha ido mal al intentar pedir el reinicio de contraseña: ',
  login_action_reset_password_success:
    'Tu contraseña ha sido actualizada correctamente',
  login_action_reset_password_error:
    '¡Ups! Algo ha ido mal al intentar reiniciar tu contraseña:  ',

  login_action_impersonate_user_info: 'Estás suplantando al usuario:  {user}',
  login_action_impersonate_user_error:
    '¡Ups! Algo ha ido mal al intentar suplantar al usuario:',
  login_action_stop_impersonation_info: 'La suplantación ha terminado',
  login_already_a_user_redirect: '¿Ya tienes cuenta?',
  login_already_a_user_redirect_login_link: 'Inicia sesión',
  login_action_login_snackbar_error_invalidad_credentials:
    '¡Ups! Algo ha ido mal al intentar iniciar sesión: Usuario o contraseña incorrectos',

  /* Reset Passcode  */
  login_change_passcode_form_submit: 'Cambiar clave',
  login_change_passcode_action_change_passcode: 'Cambiar clave',
  login_change_passcode_action_return_to_dashboard: 'Volver al panel principal',
  login_change_passcode_form_information:
    'Hola {userName}, para cambiar tu clave, rellena la información que te pedimos',
  login_change_passcode_input_new_passcode: 'Introduce tu clave nueva',
  login_change_passcode_input_repeat_passcode:
    'Vuelve a introducir la nueva clave',
  login_change_passcode_invalid_token_error:
    'No se puede realizar el cambio de clave, debes haber iniciado sesión con el usuario que solicitó el cambio o es posible que el link para cambiar el código haya caducado.',
  login_change_passcode_success_with_redirect:
    'Se ha cambiado la clave correctamente, en breve te redirigiremos al panel principal',
  user_request_reset_passcode_success:
    'Te hemos enviado un correo para que realices el cambio de tu clave',
  /* ------------------- */
  /* - Remember Password  - */
  login_password_rem_button: '¿Olvidaste tu contraseña?',
  login_password_rem_greeting: 'Restablece tu contraseña',
  login_password_rem_sent: 'Comprueba tu email',
  login_password_rem_error: 'El email que has introducido no está registrado',
  login_reset_password_form_submit: 'Cambiar contraseña',
  login_forgot_password_instructions:
    'Rellena los datos y te enviaremos instrucciones para resetear tu contraseña',

  /* -- DASHBOARD -- */
  dashboard_user_greeting: '¡Hola {user}!',
  dashboard_balance_card_title: 'Saldo',
  dashboard_balance_available: 'Disponible',
  dashboard_balance_withheld: 'Retenido',
  dashboard_balance_card_wiretransfer_recharge: 'Recargar por transferencia',
  dashboard_balance_card_fast_recharge: 'Recarga rápida',
  dashboard_account_box_available: 'saldo actual',
  dashboard_account_box_statment_period: 'Periodo de facturación',
  dashboard_account_box_payment_cycle: 'Ciclo de pago',
  dashboard_account_box_payment_cycle__monthly: 'Mensual',
  dashboard_account_box_payment_due_date: 'Fecha de pago',
  dashboard_account_box_make_payment_action: 'Añadir dinero',
  dashboard_account_box_make_payment_wire_transfer_title:
    'Añadir dinero por transferencia',
  dashboard_account_box_payment_history_action:
    'Historial de recargas y facturas',

  dashboard_account_box_movements_header: 'Historial de recargas',
  dashboard_movements_modal_zero_results: 'No hay información de recargas',
  dashboard_account_box_make_payment_text_1:
    'Añade dinero haciendo una transferencia desde cualquier banco con los siguientes datos.',
  dashboard_account_box_make_payment_text_2:
    'Te recomendamos que sea una transferencia periódica mensual. Tardará 24h-48h',
  dashboard_account_box_make_transfer_fetch_info_error: 'No hemos podido obtener los datos para la realización de la transferencia bancaria, por favor inténtalo más tarde',

  dashboard_account_box_make_card_payment_text:
    'Añade dinero al instante usando una tarjeta corporativa, emitida por cualquier banco.',
  dashboard_make_payment_bank_account: 'Número de cuenta bancaria:',
  dashboard_make_payment_bank_transfer_subject: 'Concepto:',
  dashboard_make_payment_bank_account_holder: 'Destinatario:',
  dashboard_make_payment_bank_swift_code: 'Código swift',

  dashboard_card_payment_title: 'Recarga rápida',
  dashboard_card_create_and_payment_button: 'Añadir tarjeta y recargar',
  dashboard_card_payment_button: 'Recargar',
  dashboard_card_payment_your_balance_will_be: 'Tu saldo será de',
  dashboard_card_payment_add_card: 'Nueva tarjeta',
  dashboard_card_payment_save_card: 'Guardar tarjeta',
  dashboard_card_payment_selected_card: 'Tarjeta seleccionada',
  dashboard_card_payment_selected_card_placeholder: 'Selecciona una tarjeta',
  dashboard_card_payment_selected_card_no_cards: 'No hay tarjetas',
  dashboard_card_payment_selected_card_no_results:
    'No hay tarjetas para la búsqueda actual',
  dashboard_card_payment_faq: 'Consulta los límites para hacer recargas rápidas {link}',
  dashboard_card_payment_faq_link: 'https://www.notion.so/factorialco/Haz-recargas-en-Fuell-12d0a6c82b3a4c24a481edeb2ed3881e',
  dashboard_card_payment_faq_click_here: 'aquí',
  dashboard_make_card_payment_modal_delete_card_confirm: 'Se eliminará la tarjeta con los últimos 4 digitos {cardLastDigits}, pulsa Eliminar tarjeta para confirmar o cancelar para volver',
  dashboard_make_card_payment_modal_delete_card_confirm_header: 'Eliminar tarjeta',
  dashboard_card_payment_error: '¡Ups! Algo ha ido mal al hacer el pago',
  dashboard_card_payment_success_title: '¡Dinero ingresado!',
  dashboard_card_payment_failed_title: 'Ha habido un error',
  dashboard_card_payment_success_message: 'Tu saldo es de',
  dashboard_card_payment_failed_message: 'No se ha podido hacer la recarga, no se te cobrará nada en la tarjeta.',
  dashboard_card_payment_failed_support: 'Contacte con soporte para obtener más información.',
  dashboard_card_payment_failed_reasons: 'Es posible que se hayan superado los límites de recarga:',
  dashboard_card_payment_failed_reasons_1: 'Tarjeta por día: 3.000€',
  dashboard_card_payment_failed_reasons_2: 'Empresa por día: 5.000€',
  dashboard_card_payment_failed_reasons_3: 'Empresa por 7 días naturales: 6.000€',
  dashboard_card_payment_failed_reasons_4: 'Empresa en los anteriores 30 días naturales: 9.000€',
  dashboard_card_payment_make_payment_invalid_amount:
    'Por favor, introduce una cantidad superior a 0 para continuar',
  dashboard_card_payment_make_payment_invalid_card:
    'Por favor, selecciona una tarjeta o la opción Nueva tarjeta para continuar',

  dashboard_top_up_history_action_download_invoice: 'Descargar factura',
  office_fetch_issuer_balance_error:
    '¡Ups! Algo ha ido mal al intentar obtener la información de saldo',
  dashboard_fetch_movements_error:
    '¡Ups! Algo ha ido mal al intentar obtener el historial de movimientos',
  dashboard_download_invoice_error:
    '¡Ups! Algo ha ido mal al intentar descargar la factura',
  office_fetch_tokenized_cards_error:
    '¡Ups! Algo ha ido mal al intentar obtener las tarjetas guardadas',
  office_delete_tokenized_cards_error:
    '¡Ups! Algo ha ido mal al intentar eliminar la tarjeta guardada',

  /* - Dashboard graphic keys - */
  dashboard_graphic_header: 'Evolución de gastos',
  dashboard_graphic_header_budgets: 'Evolución de gastos (por presupuestos)',
  dashboard_graphic_header_categories: 'Evolución de gastos (por categorías)',
  dashboard_graphic_merchant_filter: 'Filtrar por comercio',
  dashboard_graphic_date_selector_filter: 'Filtrar por periodo',
  dashboard_selector_group_by: 'Agrupar por:',
  dashboard_graphic_group_selector_delimited_by_expense_type: 'Gasto total',
  dashboard_graphic_group_selector_delimited_by_budget: 'Gasto por presupuesto',
  dashboard_graphic_group_selector_delimited_by_category: 'Gasto por categoría',

  dashboard_graphic_expenses_group_by_month: 'Gastos por mes',
  dashboard_graphic_expenses_group_by_day: 'Gastos por día',
  dashboard_graphic_date_selector_filter_today: 'Hoy',
  dashboard_graphic_date_selector_filter_last_seven_days: 'Últimos 7 días',
  dashboard_graphic_date_selector_filter_last_thirty_days: 'Últimos 30 días',
  dashboard_graphic_date_selector_filter_last_year: 'El año pasado',
  dashboard_graphic_date_selector_filter_current_year:
    'El año actual (enero hasta hoy)',
  dashboard_graphic_date_selector_filte_custom_range:
    'Personalizar el rango de fechas...',
  dashboard_graphic_group_selector_group_by_days: ' Agrupar por días',
  dashboard_graphic_group_selector_group_by_month: 'Agrupar por mes',
  dashboard_time_selector_modal_header:
    'Seleccionar rango de fechas personalizado',
  date_picker_input_range_selector: 'Rango de fechas',
  dashboard_fetch_expense_dashboard_data_error:
    '¡Ups! Algo ha ido mal al intentar obtener los datos para las gráficas',

  /* Dashboard insights keys */
  dashboard_insight_expense_word: 'Gastos hechos',
  dashboard_insight_header_people: 'Gastos por empleados',
  dashboard_insight_header_mileage: 'Gastos en kilometrajes',
  dashboard_insight_header_budgets: 'Gastos en presupuestos',
  dashboard_fetch_people_insight_error:
    '¡Ups! Algo ha ido mal al intentar obtener los gastos por persona',
  dashboard_fetch_mileage_insight_error:
    '¡Ups! Algo ha ido mal al intentar obtener los gastos en kilometrajes',
  dashboard_fetch_budget_insight_error:
    '¡Ups! Algo ha ido mal al intentar obtener los gasos por presupuestos',
  dashboard_insight_card_table_header_name: 'Nombre',
  dashboard_insight_card_table_header_spent_percentage: '% Gastado',
  dashboard_insight_card_table_header_spent_in_current_month: 'Gasto del mes',
  dashboard_insight_card_table_header_spent_percentage_change: '% Cambio',
  dashboard_insight_card_table_header_transactions_amount: 'Transacciones',
  dashboard_insight_card_table_header_transactions_missing_info:
    'Falta información',
  dashboard_insight_card_table_header_transactions_not_reviewed:
    'Falta revisión',
  dashboard_insight_card_table_no_data:
    'Aún no tenemos datos de uso para mostrarte, ¡pero a medida que se generen aparecerán aquí!',
  dashboard_graphic_date_selector_range_from: 'desde',
  dashboard_graphic_date_selector_range_to: 'hasta',

  /* Dashboard tasks keys */
  dashboard_tasks_title: 'Tus tareas',
  dashboard_team_tasks_title: 'Tareas del equipo',
  dashboard_task_list_incomplete_tasks: 'Transacciones por completar',
  dashboard_task_list_not_reviewed_tasks: 'Transacciones por revisar',
  dashboard_task_list_incompleted_reimbursements_tasks:
    'Gastos por completar',
  dashboard_task_list_not_reviewed_reimbursements_tasks:
    'Gastos por revisar',
  dashboard_task_completed_title: '¡No tienes tareas pendientes!',
  dashboard_task_completed_body:
    'Has terminado con todas las aprobaciones pendientes',

  dashboard_task_completed_body_navigate:
    '¡Buen trabajo! Puedes hacer {link} para ver todos tus gastos',
  dashboard_task_period_current_month: 'Mes actual',
  dashboard_task_period_current_week: 'Esta semana',
  dashboard_task_period_current_quarter: 'Trimestre actual',
  dashboard_task_period_current_year: 'Este año',
  dashboard_task_period_history: 'Histórico',
  dashboard_task_list_notification_link: 'Enviar notificación de tareas pendientes',

  // NOTIFICATION TASKS MODAL
  send_notification_tasks_modal_title: 'Enviar notificación',
  send_notification_tasks_modal_message: 'Enviaremos una notificación de tu parte a los usuarios con el tipo de tareas pendientes que selecciones.',
  send_notification_tasks_confirm_modal_message: '¿Estás seguro de enviar las notificaciones? Recuerda que abusar de esta función puede hacer que los empleados ignoren las alertas.',
  send_notification_tasks_confirm_modal_message_send: 'Sí, enviar',
  send_notification_tasks_modal_message_radio_title: 'Tipo de notificación a enviar',
  send_notification_tasks_modal_message_radio_message: 'Seleccione qué notificación quieres enviar',
  send_notification_tasks_modal_radio_complete: 'Completar gastos en ',
  send_notification_tasks_modal_radio_review: 'Revisar gastos ',
  send_notification_tasks_modal_radio_complete_italic: 'Falta información',
  send_notification_tasks_modal_radio_review_italic: 'Pendientes de revisión',
  send_notification_tasks_modal_message_send: 'Enviar notificación',

  /* ------- USERS ---------- */
  users_invite_massive_upload: 'Subida masiva',
  users_users_section_header: 'Usuarios',
  users_user_signup_button: 'Invitar Usuarios',
  users_invite_user: 'Invitar usuario',
  users_add_user: '+ Añadir Usuario',
  users_expense_type_label: 'Forma de gasto del usuario',
  users_expense_type_label_optional_cards: 'Puedes decidir si el usuario funcionará con tarjetas virtuales, si quieres que se le envíe una tarjeta física o si solamente podrá subir gastos a la plataforma de forma manual.',
  users_expense_type_label_cards: 'Puedes decidir si el usuario funcionará únicamente con tarjetas virtuales o si quieres que se le envíe una tarjeta física.',
  users_user_export: 'Exportar usuarios',
  users_user_export_file: 'Listado de usuarios {exportDate}',
  users_import_users: 'Importar Usuarios',
  users_import_users_description:
    'Para realizar una invitacion masiva a todo tu equipo {downloadLink}. A continuación rellénala con los datos y súbela de nuevo aquí.',
  users_import_optional_card_warning:
    'Por favor, comprueba que rellenas todas las columnas de la plantilla, en caso de no rellenar las celdas de la columna "Tarjeta", se le emitirá la tarjeta física al usuario.',
  users_import_users_download_template: 'descárgate esta plantilla',
  users_import_invalid_file:
    'El archivo que has seleccionado no es válido, intentalo de nuevo usando nuestra plantilla.',
  users_import_invalid_users:
    'Los siguientes usuarios son inválidos, soluciona los problemas en el archivo y vuelve a enviarlo para continuar.',
  users_import_violation_email_already_in_use: 'Correo electrónico en uso',
  users_import_violation_invalid_email: 'Correo electrónico inválido',
  users_import_violation_no_name: 'Sin nombre',
  users_import_violation_no_role: 'Sin rol',
  users_import_violation_email_already_in_use_on_import:
    'Correo electrónico repetido en el archivo',
  users_import_confirm_intro:
    'Estos son los datos que hemos extraído del archivo. Comprueba que sean correctos y a continuación haz click en continuar.',
  users_import_button_wrong_file: 'Me he equivocado de archivo',
  users_import_table_name: 'Nombre',
  users_import_table_email: 'Correo electrónico',
  users_import_table_issue: 'Problema',
  users_import_table_gross_salary: 'Salario bruto',
  users_import_table_role: 'Rol',
  users_import_table_card_emission: 'Tarjeta',
  users_import_select_file_text:
    'Arrastra aquí tu archivo de usuarios o haz click para seleccionarlo',
  users_import_selected_file_intro:
    'Vamos a procesar el archivo y verificar que todo es correcto.',
  users_import_invitations_sent:
    '✅ Se han enviado las invitaciones a los usuarios',
  users_import_invitations_waiting_approval:
    'Gracias, estamos procesando tu solicitud.',
  users_import_invitations_waiting_approval_contact:
    'Contáctanos por chat si necesitas ayuda.',
  users_import_confirm_modal_message:
    'Se van a añadir {count} , de los cuales {regular} son usuarios normales y {bookkeeper} contables',
  users_import_loading_error: 'Ha ocurrido un error cargando los datos',
  users_import_accept_error:
    'Ha ocurrido un error creando los usuarios o enviando las invitaciones',
  users_import_accept_completed:
    'Se han creado los usuarios y se han enviado las invitaciones',
  users_import_reject_error:
    'Ha ocurrido un error rechazando la subida de usuarios',
  users_import_reject_completed: 'Se ha rechazado la subida de usuarios',
  users_import_validation_description:
    'La empresa quiere importar los siguientes usuarios',
  users_import_already_completed: 'La subida de usuarios ya se ha realizado',
  users_tab_section_active: 'Activos',
  users_tab_section_archived: 'Archivados',
  users_user_signup_section_send_invites: 'Enviar Invitaciones',
  users_customers_admin_impersonate_customer_admin: 'Suplantar Administrador',
  users_customers_admin_impersonate_user: 'Suplantar usuario',
  users_user_invitation_request_card: 'Solicitar tarjeta',
  user_status__INVITE_BY_SUPER_ADMIN: 'Pendiente de Activar',
  user_status__INVITE_BY_ADMIN: 'Pendiente de Activar',
  user_status__ACTIVE: 'Usuario Activo',
  user_status__ARCHIVE: 'Usuario Archivado',
  user_status__DELETED: 'Usuario Eliminado',
  user_role__ROLE_ADMIN: 'Administrador',
  user_role__ROLE_ADMIN_OWNER: 'Account holder',
  user_role__ROLE_ACCOUNT_HOLDER: 'Account holder',
  user_role__ROLE_BOOKKEEPER: 'Contable',
  user_role__ROLE_REGULAR: 'Normal',
  user_role__ROLE_SUPER_ADMIN: 'Superadministrador',
  user_role__ROLE_COMMERCIAL: 'Comercial',
  user_role__ROLE_SUPER_BOOKKEEPER: 'Super contable',
  user_role_help_text: '¿Qué rol es el más adecuado?',
  user_role_read_more: 'Leer más.',

  /* - Customer Terms - */
  customers_tabs_customer: 'Clientes',
  customers_tabs_users: 'Usuarios',
  customer_creation_header: 'Añadir Cliente',
  customer_information_header: 'Sociedad',
  customer_creation_social_reason: 'Razón Social',
  customer_creation_social_or_billing_information:
    'Domicilio social / Dirección de facturación',
  customer_creation_office_configuration: 'Configuración de la empresa',
  customer_creation_office_card_usage: 'Uso de tarjetas para la empresa',
  customer_creation_zoho_pricing_plan: 'Plan de precios',
  customer_creation_zoho_pricing_plan_tooltip:
    'Selecciona plan de precios para ésta empresa. Estos planes se deben crear con anterioridad en Zoho para que aparezcan aquí listados. La información se generará en Zoho una vez que el administrador de la empresa termine el onboarding.',
  customer_creation_office_card_usage_tooltip:
    'Selecciona si la empresa operará con tarjetas, sin tarjetas, o se le dará la posibilidad a los administradores de decidir si los usuarios utilizarán o no la tarjeta de fuell.Por defecto si no se indica, se crean con tarjeta',
  customer_creation_fuell_admin_data: 'Admin cuenta Fuell',
  customer_creation_fuell_admin_card_usage: 'Uso de tarjeta',
  customer_creation_fuell_admin_card_type_emission: 'Tipo de tarjeta a emitir',
  customer_creation_fuell_admin_card_usage_tooltip:
    'Sólo si la empresa tiene uso de tarjetas opcional, selecciona si el administrador de la empresa tendrá o no tarjeta',
  customer_creation_card_record: 'Grabado en tarjetas',
  customer_creation_card_company_name_on_record:
    'Nombre de empresa en la tarjeta',
  customer_creation_card_send_address: ' Dirección de envío de tarjetas',
  customer_creation_office_other: 'Otros datos',
  customer_creation_invite_customer: 'Invitar',
  customer_update_customer_types: 'Actualizar listado de precios',
  customer_creation_registration_number: 'Número CIF',
  customer_creation_office_admin_header: 'Datos del Administrador',
  customer_creation_office_header: 'Datos de la Oficina',
  customer_creation_office_contact_person: 'Persona de Contacto',
  customer_creation_office_board_members: 'Miembros de la Junta',
  customer_creation_office_current_balance: 'Balance Actual',
  customer_creation_office_balance_alert_threeshold:
    'Alerta de límite de umbral de gasto',
  customer_list_table_header_name: 'Nombre de Empresa Cliente',
  customer_list_table_header_registration_number: 'CIF',
  customer_list_table_header_customer_office_admin: 'Administrador',
  customer_list_table_header_customer_client_type: 'Tipo Cliente',
  customer_list_table_header_customer_office_admin_status: 'Estado del Admin.',
  customer_list_table_header_customer_card_usage_type: 'Emisión de tarjeta',
  customer_status_ACTIVE: 'Cliente Activo',
  customer_status_ARCHIVED: 'Cliente Archivado',
  customer_actions_modal_header: 'Acciones de Cliente',
  customer_actions_modal_customer_actions: 'Acciones de empresa',
  customer_actions_modal_customer_information: 'Información de la empresa',
  customer_onboarding_header: 'Onboarding',
  customer_onboarding_type__STANDARD: 'Normal',
  customer_onboarding_type__SELF_ONBOARD: 'Web',
  customer_onboarding_type__WITHOUT_CUSTOMER: 'App',

  customer_new_customer_user_to_invoice: 'Cantidad mínima de usuarios a facturar',
  customer_new_customer_billing_starts_at: 'Comenzar a facturar a partir del',
  customer_new_customer_billing_starts_at_placeholder: 'Selecciona fecha de comienzo de facturación',
  customer_new_customer_devoluiva: 'Activar DevoluIVA para esta empresa',
  customer_new_customer_allow_shipping_address: 'Utilizar esta dirección para enviar todas las tarjetas que se emitan.',
  customer_new_customer_allow_shipping_address_info: 'Si marcas esta casilla no se le permitirá al empleado seleccionar dirección de envío y todas las tarjetas llegarán a esta dirección por defecto.',

  customer_creation_fuell_attorney_data: 'Información del apoderado de la cuenta',
  customer_new_customer_attorney_document: 'Indentificación (DNI...)',
  customer_new_customer_attorney_date_of_birth: 'Fecha de nacimiento',
  customer_convert_to_card_user_document_expiration_date: 'Fecha de caducidad del DNI',
  /* customer billing terms  */
  customers_bill_client_header: 'Cobro a clientes',
  customers_bill_client_amount: 'Cantidad',
  customers_bill_client_message:
    'Vas a realizar un cobro al cliente {customerName}, introduce la cantidad y tu clave para continuar',
  customers_bill_client_action: 'Cobrar a cliente',
  customers_bill_client_success: 'Cobro realizado correctamente',
  customers_bill_client_error:
    '¡Ups! Hemos tenido un problema al realizar el cobro al cliente',
  customers_confirm_archive_header_action: 'Archivar cliente',
  customers_confirm_activate_header_action: 'Activar cliente',
  customers_confirm_toggle_archive_customer_status:
    'Estás a punto de archivar al cliente {customerName}, para continuar pulsa Archivar cliente, de lo contrario pulsa Cancelar',
  customers_confirm_toggle_activate_customer_status:
    'Estás a punto de activar al cliente {customerName}, para continuar pulsa Activar cliente, de lo contrario pulsa Cancelar',
  customers_user_actions_reequest_card: 'Solicitar envío de tarjeta',
  customers_user_cards: 'Tarjetas',
  customer_user_without_cards: 'Usuario sin tarjetas',
  customer_user_with_virtual_cards: 'Usuario con tarjetas virtuales',
  customer_user_request_physical_card: 'Solicitar tarjeta física',
  customer_user_convert_to_user_with_cards: 'Convertir en usuario con tarjetas',
  customer_user_actions_cancel_card: 'Cancelar tarjeta con MP: {numMP}',
  customer_user_card_not_emmited: 'NO EMITIDA',
  customers_users_request_card_action: 'Solicitar tarjeta',
  customers_users_request_card_info: 'Vas a solicitar una tarjeta para el usuario {userName}, rellena la información solicitada y pulsa solicitar tarjeta para continuar',
  customers_users_request_card_no_sending_info: 'Vas a solicitar una tarjeta para el usuario {userName}, pulsa solicitar tarjeta para confirmar.',
  customers_users_request_card_success: 'Se ha solicitado la tarjeta correctamente',
  customers_users_request_card_summary_info: 'Estás a punto de solicitar una tarjeta para el usuario {userName}. {verify} y pulsa Solicitar tarjeta para continuar. Si necesitas cambiar la información pulsa Cancelar y edítala',
  customers_users_request_card_summary_info_verify: 'Por favor comprueba que la información es correcta',
  customers_users_request_card_error: '¡Ups! Algo ha ido mal al intentar solicitar la tarjeta',
  customers_users_convert_to_card_user_header: 'Convertir en usuario con tarjetas',
  customers_users_convert_to_card_user_info: 'Vas a solicitar el alta del usuario {userName} en Pecunpay para que el usuario pueda utilizar tarjetas, rellena la información solicitada y pulsa Convertir en usuario con tarjetas para continuar',
  customers_users_convert_to_card_user_submit: 'Convertir en usuario con tarjetas',
  customers_users_convert_to_card_user_summary_info: 'Estás a punto de convertir al usuario {userName} en usuario con tarjetas. {verify} y pulsa Convertir en usuario con tarjetas para continuar. Si necesitas cambiar la información pulsa Cancelar y edítala',
  customers_users_convert_to_card_user_summary_info_verify: 'Por favor comprueba que la información es correcta',

  customers_users_convert_to_cards_user_success: 'Se ha enviado la solicitud para dar de alta al usuario en Pecunpay',
  customers_users_conver_to_cards_user_error: '¡Ups! Algo ha ido mal al intentar solciitr el alta de usuario en Pecunpay',
  customers_users_actions_cancel_card_confirm: 'Estás a punto de cancelar la tarjeta del usuario {userName}, con número MP, {numMP}, ésta acción no se puede deshacer, pulsa Cancelar tarjeta para continuar, o pulsa Cancelar para volver',
  customers_users_actions_cancel_card_confirm_action: 'Cancelar tarjeta',
  customers_users_actions_cancel_card_success: 'Se ha cancelado la tarjeta correctamente',
  customers_users_actions_cancel_card_error: '¡Ups! Hemos tenido un problema al intentar cancelar la tarjeta',
  customer_actions_request_otp: 'La acción que vas a realizar requiere que solicites el One Time Password (OTP). Al pulsar en Solicitar OTP te llegará un sms con un clave de un solo uso para confirmar la acción, introducela y pulsa  confirmar',
  customer_actions_request_otp_action: 'Solicitar OTP',
  customer_actions_request_otp_warning: 'Si el OTP tarda más de un minuto en llegarte a tus mensajes, vuelve a solicitarlo pulsando Solicitar OTP',
  customer_actions_request_otp_in_progress: 'Generando OTP, revisa tus SMS...',
  customer_actions_otp_requested_warning: 'Se te ha enviado una clave por SMS, utilízala para validar la operación. Si no la has recibido, vuelve a solicitarla',
  customer_action_remove_users: 'Eliminar todos los usuarios',
  customers_action_remove_users_confirm_modal_title: 'Confirmar eliminar todos los usuarios',
  customers_action_remove_users_confirm_modal_body: 'Se eliminarán todos los usuarios de la empresa. Al terminar se te enviará un correo confirmando el resultado de la operación. Pulsa confirmar para continuar.',
  customer_remove_users_action_success: 'Se ha solicitado la eliminación de todos los usuarios correctamente',
  customer_remove_users_action_error: '¡Ups! Hemos tenido un problema al solicitar la eliminación de los usuarios',
  /* Customer Funds Transfer terms */
  customer_action_transfer_funds: 'Transferencia bancaria de fondos',
  customer_action_transfer: 'Hacer devolución',
  customer_action_manage_office_features: 'Gestionar funcionalidades',
  customer_action_archive: 'Archivar empresa',
  customer_action_restore: 'Restaurar empresa',
  customers_funds_transfer_modal_header: 'Transferir fondos a cuenta bancaria',
  customers_funds_transfer_modal_confirm_transfer: 'Transferir fondos',
  customers_transfer_funds_to_bank_account_message:
    'Vas a transferir fondos de la cuenta del cliente {customerName} a una cuenta bancaria a través de su número IBAN, completa la información y pulsa enviar.',
  customer_amount_to_transfer: 'Cantidad de la transferencia',
  customer_transfer_concept: 'Concepto',
  customer_transfer_iban_bank_number: 'Número IBAN de la cuenta de destino',
  customer_transfer_beneficiary_name: 'Nombre del beneficiario',

  /* - Customer  office Feauture Activation */
  customer_data_error: 'Hemos tenido un problema al obtener la informacion del cliente',
  office_features_activation: 'Activar características',
  office_feature_activate_rf: 'Activar Retribución Flexible',
  office_feature_activate_benefits: 'Activar Beneficio Social',
  office_feature_activate_devoluiva: 'Activar Devoluiva',
  office_feature_rf_activated: 'Retribución flexible activada',
  office_feature_bf_activated: 'Beneficios sociales activados',
  office_feature_devoluiva_activated: ' Devoluiva activado',
  office_feature_activate_rf_header: 'Activar Retribución Flexible',
  office_feature_warning:
    'Estás a punto de activar la característica {featureName}, para la empresa {customerName}. {featureWarningDanger}, así que por favor, confirma los datos de la empresa a la que se le va a activar y pulsa confirmar',
  office_feature_warning_danger:
    'Ésta característica no se puede desactivar de forma sencilla',
  office_feature_activation_success:
    'Se ha activado la característica correctamente',
  office_feature_feature_not_found_error:
    'No se ha encontrado la caractrística a activar, vuelve a intentarlo más tarde',
  office_feature_activation_error:
    '¡Ups! Hemos tenido un problema al intentar activar esta característica',

  confirm_save_changes_modal: 'Guardar cambios',
  confirm_save_changes_modal_message: '¿Estás seguro de guardar los cambios? Esta configuración afectará a toda la empresa',
  confirm_close_save_changes_modal: 'Cerrar ventana',
  confirm_close_save_changes_modal_message: '¿Estás seguro de cerrar la ventana? No se aplicarán los cambios efectuados',

  /* --- */
  manage_office_features_header: 'Gestionar funcionalidades',
  manage_office_feature_FLEXIBLE_REMUNERATION: 'Retribución flexible',
  manage_office_feature_SUBVENTION_FEATURE: 'Beneficios sociales',
  manage_office_feature_EXPORT_FUNNEL_FEATURE: 'Exportación personalizada',
  manage_office_feature_MULTI_CURRENCIES_FEATURE: 'Multimoneda',
  manage_office_feature_WATERMARK: 'Marca de agua',
  manage_office_feature_OWNER_INVITE_USER: 'Propietarios de presupuesto pueden invitar',
  manage_office_feature_AUTO_EXCHANGE: 'Auto exchange',
  manage_office_feature_AVOID_RESTART_FUNNEL_POST_EDIT_TRANSACTION: 'Editar no reinicia la revisión',
  manage_office_feature_DEVOLUIVA: 'DevoluIVA',
  manage_office_feature_MANUAL_EXPENSES_REIMBURSE: 'Permitir crear abonos',
  manage_office_feature_SHOW_BUDGET_FIELDS: 'Añadir campos extra de presupuesto',
  manage_office_feature_tooltip_AUTO_EXCHANGE: 'Al activarla, la cuantía del gasto y la cuantía en la moneda original cogen siempre la información de lo que lea el OCR.',
  manage_office_feature_tooltip_AVOID_RESTART_FUNNEL_POST_EDIT_TRANSACTION: 'Si está activo, cuando un gasto es editado y está en un flujo de aprobación, no se vuelve al primer paso del flujo de aprobación.',
  manage_office_feature_tooltip_MANUAL_EXPENSES_REIMBURSE: 'Al activarlo, las empresas tendrán la posibilidad de crear abonos manualmente al crear un gasto',
  /* - Users Terms  - */
  users_identifier: 'Identificador',
  users_expense_center: 'Centro de gasto',
  users_physical_card_status: 'Estado Tarjeta Física',
  users_budgets: 'Presupuestos',
  user_dni: 'DNI',
  user_list_table_header_invited_on: 'Fecha Invitación',
  user_list_table_header_flexible_retribution: 'Ret. Flex. Comida',
  user_list_table_header_gross_salary: 'Salario bruto anual',
  users_create_commercial: 'Crear comercial',
  users_superadmin_create_commercial_modal_header: 'Creación de comercial',
  users_superadmin_create_commercial_action_create: 'Crear comercial',
  users_superadmin_create_commercial_success:
    'Se ha creado el comercial correctamente',
  users_superadmin_create_commercial_error:
    '¡Ups! Hemos tenido un problema al intentar crear el usuario comercial',
  users_create_super_book_keeper: 'Crear super contable',
  users_superadmin_create_super_book_modal_header:
    'Creación de usuario super contable',
  users_superadmin_create_superbook_action_create: 'Crear super contable',
  users_superadmin_create_superbook_success:
    'Se ha creado el super contable correctamente',
  users_superadmin_create_superbook_error:
    '¡Ups! Hemos tenido un problema al intentar crear al super contable',
  /* -  User Details  - */
  user_detail_action_edit_profile: 'Editar Perfil',
  user_detail_action_activate_user: 'Activar Usuario',
  user_detail_action_archive_user: 'Archivar Usuario',
  user_detail_tab_overview: 'Resumen',
  user_detail_tab_member_cards: 'Tarjetas',
  user_detail_tab_transactions: 'Transacciones',
  user_detail_tab_budgets: 'Presupuestos',
  user_detail_tab_benefits: 'Beneficios',
  user_detail_tab_reimbursements: 'Gastos',

  user_detail_toggle_status_confirm_archive_header_action: 'Archivar usuario',
  user_detail_toggle_status_confirm_restore_header_action: 'Activar usuario',

  user_detail_toggle_status_confirm_archive_warning:
    'Estás a punto de archivar al usuario {user}, para continuar pulsa Archivar usuario, de lo contrario pulsa Cancelar',
  user_detail_toggle_status_confirm_restore_warning:
    'Estás a punto de activar al usuario {user}, para continuar pulsa Activar usuario, de lo contrario pulsa Cancelar',

  /* - Self Onboarding  - */
  user_self_onboarding_create_account: '¿No tienes cuenta? {signup}',
  user_self_onboarding_create_account_signup_here: 'Regístrate aquí',
  user_self_onboarding_register_now_label:
    'Regístrate y empieza a usar nuestro software sin coste alguno',
  user_self_onboarding_sign_up_personal_data: 'Introduce tus datos personales',
  user_self_onboarding_sign_up_company_data:
    'Introduce los datos de tu empresa',
  user_self_onboarding_sign_up_create_security_passcode:
    'Crea un pin de seguridad',
  user_self_onboarding_accept_tcs: 'He leído y acepto las {tc},{sc} y {pp}',
  user_self_onboarding_tc: 'Condiciones de uso',
  user_self_onboarding_sc: 'Condiciones de los servicios',
  user_self_onboarding_pp: 'Política de privacidad',
  user_self_onboarding_company_name: 'Nombre de la empresa',
  user_self_onboarding_complete_onboarding: 'Empezar a usar Fuell',
  user_self_onboarding_completed_check_email:
    '¡Ya casi hemos terminado! Revisa tu email para activar tu cuenta',
  user_self_onboarding_completed_repeat_check:
    'Si pasados unos minutos no recibes el mail haz click {click}',

  user_self_onboarding_cif_number: 'CIF',
  user_self_onboarding_passcode_info:
    'Por motivos de seguridad necesitamos que crees un {digitsbolder} con el que poder acceder a la app de Fuell.',
  user_self_onboarding_passcode: 'Pin de seguridad',
  user_self_onboarding_passcode_placeholder: 'Pin de 4 dígitos',
  user_self_onboarding_repeat_passcode: 'Repetir pin',
  user_self_onboarding_repeat_passcode_placeholder: 'Repite el pin',

  user_self_onboarding_error:
    '¡Ups! Hemos tenido un problema al intentar dar de alta',
  user_self_onboarding_activation_success:
    '¡Ya hemos terminado! Tu cuenta se ha activado correctamente',
  user_self_onboarding_activation_success_redirection:
    '{click} si tu navegador no te redirige automáticamente',
  user_self_onboarding_activation_failure:
    'Hemos tenido un problema para activar tu cuenta',
  user_self_onboarding_activation_failure_contact_support:
    'Es posible que tu enlace de activación no sea válido o ya se haya utilizado.{customerSupport} para que te echemos una mano',
  user_self_onboarding_activation_failure_message:
    'Hola, acabo de intentar activar mi cuenta pero he tenido un error ¿me podéis ayudar?',

  /* - Accept Invitation - */
  user_accept_invitation_header: 'Invitación a Fuell',
  user_accept_invitation_body:
    'Rellena la información requerida y pulsa enviar',
  user_invitation_form_complete_registration: 'Completa tu registro',
  user_invitation_form_identification: 'Identificación',
  user_invitation_form_dni_expiration_date: 'Fecha Caducidad (DD/MM/YYYY)',
  user_invitation_form_id: 'Documento de identificación personal (DNI, NIF...)',
  user_invitation_form_email_no_spam:
    'Necesitamos tu teléfono móvil para hacer tu cuenta segura, no para enviarte publicidad.',
  user_invitation_form_select_expiration_date:
    'Selecciona fecha de caducidad del DNI',
  user_invitation_form_create_passcode:
    'Hola {name}, crea una clave de {digits} dígitos para tu cuenta',
  user_invitation_form_create_passcode_not_card_pin:
    'Este NO es el pin de tu tarjeta.',
  user_invitation_form_create_passcode_text:
    'Ese te lo pediremos cuando accedas a tu tarjeta virtual o hagas cambios en la cuenta. Nosotros tampoco podemos verlo.',
  user_invitation_form_create_passcode_confirmation: 'Confirma tu clave',
  user_invitation_form_create_passcode_confirmation_text:
    'Escribe la misma clave otra vez',
  user_invitation_form_create_passcode_confirmation_not_match:
    'Las claves no coinciden, inténtalo otra vez',
  user_invitation_form_accept_terms: 'Por favor lee y acepta nuestros términos',
  user_terms_accept_label:
    'He leido y acepto los ',
  user_terms_accept_label_new:
    'He leido y acepto los nuevos ',
  user_invitation_form_token_not_found:
    'Este enlace de invitación no es válido o ya se ha utilizado. Si estás registrado, vete a la página de login donde podrás entrar o recuperar tu contraseña',
  user_accept_invitation_redirect_login: 'Llévame a la página de login',
  user_invitation_form_token_expired:
    'Hemos recibido tu invitación pero tras pasar 24h sin activarse, ha caducado, contacta con tu administrador para reactivarla',
  user_terms_general_conditions: 'Condiciones de uso',
  user_terms_general_conditions_explanation:
    'Condiciones de uso de la plataforma',
  user_terms_service_conditions: 'Condiciones de los servicios',
  user_terms_service_conditions_explanation:
    'Condiciones de los servicios ofrecidos por Fuell',
  user_terms_privacy_policy:
    'Política de privacidad de Fuell',
  user_terms_privacy_policy_explanation:
    'Cómo mantenemos tus datos privados seguros',
  user_terms_payment_service_conditions:
    'Condiciones de los servicios de pago',
  user_terms_payment_service_conditions_explanation:
    'Condiciones del proveedor de servicios de pago',
  user_reset_password_token_expired: 'El enlace para solicitar el cambio de contraseña ha caducado. Puedes volver a la página de inicio de sesión y solicitar el cambio pulsando sobre "¿Olivdaste tu contraseña?"',
  user_reset_password_token_generic_error: 'El enlace para solicitar el cambio de contraseña ya ha sido utilizado o no es válido. Puedes volver a la página de inicio de sesión y solicitar el cambio pulsando sobre "¿Olvidaste tu contraseña?"',

  user_invitation_card_send_address: 'Dirección de envío de la tarjeta',
  user_invitation_card_send_option_send_to_office: 'Enviar a oficina',
  user_invitation_card_send_option_send_to_other: 'Enviar a otra dirección',
  /* - Profile Section */
  user_profile_personal_details_tab: 'Detalles Personales',
  user_profile_preferences_tab: 'Preferencias',
  user_profile_job_title: 'Puesto',
  user_profile_email: 'Correo de Empresa',
  user_profile_create_passcode: 'Crear clave',
  user_profile_change_passcode: 'Cambiar clave',
  user_profile_old_passcode: 'Clave actual',
  user_profile_new_passcode: 'Nueva clave',
  user_profile_change_passcode_instructions_warning:
    'Ésto cambiará tu clave, no el PIN de tu tarjeta',
  user_profile_change_passcode_step_one: 'Introduce tu clave actual',
  user_profile_change_passcode_step_two: 'Introduce tu nueva clave',
  user_profile_change_passcode_step_three: 'Confirma tu nueva clave',
  user_profile_change_passcode_success: 'Clave actualizada',
  user_profile_change_passcode_passcode_mismatch:
    'Las claves introducidas no coinciden',
  user_action_change_passcode_submit: 'Cambiando clave...',
  user_profile_set_passcode_instructions:
    'Completa la información y pulsa Crear clave para crearla',
  user_set_passcode_success: 'Se ha creado la clave correctamente',
  user_profile_upgrade_to_admin: 'Hacer administrador',
  user_profile_change_password: 'Cambiar contraseña',
  user_profile_change_password_message: 'Introduce la nueva clave de cuatro dígitos para que el usuario acceda a la app',
  user_profile_form_forgot_passcode_action: '¿Has olvidado tu clave?',
  user_profile_forgot_passcode_modal_header: 'Recuperar clave',
  user_profile_forgot_passcode_confirm_request_reset_passcode: 'Enviar email',
  user_profile_forgot_passcode_message:
    'Te enviaremos un email para que cambies tu clave',
  user_profile_forgot_passcode_explain:
    'Para recuperar tu clave escríbenos a {0} o contáctanos por chat ',
  user_set_passcode_error:
    '¡Ups! Algo ha ido mal al intentar crear la clave para el usuario',
  user_update_passcode_success:
    'Se ha actualizado la clave del usuario correctamente',
  users_change_user_password_success:
    'Se ha actualizado la contraseña del usuario correctamente',
  user_update_passcode_error:
    '¡Ups! Algo ha ido mal al intentar actualizar la clave del usuario',
  user_action_fetch_user_error:
    '¡Ups! Algo ha ido mal al intentar obtener la información del usuario',
  user_change_user_password_error:
    '¡Ups! Algo ha ido mal al intentar cambiar la contraseña del usuario',
  user_profile_picture_updated: 'Se ha actualizado la imagen de perfil',
  user_profile_picture_error:
    '¡Ups! Algo ha ido mal al intentar cambiar imagen de tu perfil',

  user_profile_settings_ACCOUNT_LOW_BALANCE: 'Saldo de empresa bajo',
  user_profile_settings_ACCOUNT_LOW_BALANCE_comment:
    'Te avisaremos antes de que te quedes sin fondos en tu empresa',
  user_profile_settings_ACCOUNT_BALANCE_AVAILABLE: 'Nuevos fondos disponibles',
  user_profile_settings_ACCOUNT_BALANCE_AVAILABLE_comment:
    'Te avisaremos cuando recibas nuevos fondos en tu empresa',
  user_profile_settings_ACCOUNT_AVAILABLE_BALANCE_LOWER_THAN_ASSIGNED:
    'Fondos insuficientes',
  user_profile_settings_ACCOUNT_AVAILABLE_BALANCE_LOWER_THAN_ASSIGNED_comment:
    'Te avisaremos cuando los fondos en tu empresa sean menos que el saldo total disponible para los usuarios de la empresa',
  user_profile_settings_TRANSACTION_3_DAYS_BEFORE_END:
    'Cierre de transacciones próximo',
  user_profile_settings_TRANSACTION_3_DAYS_BEFORE_END_comment:
    'Te avisaremos 3 días antes del cierre mensual de las transacciones corporativas de tu empresa',
  user_profile_settings_TRANSACTION_3_DAYS_BEFORE_END_BENEFITS:
    'Cierre de beneficios próximo',
  user_profile_settings_TRANSACTION_3_DAYS_BEFORE_END_BENEFITS_comment:
    'Te avisaremos 3 días antes del cierre mensual de las transacciones con beneficios de tu empresa',
  user_profile_settings_INVITED_TO_BUDGET: 'Invitación a presupuesto',
  user_profile_settings_INVITED_TO_BUDGET_comment:
    'Te avisaremos cuando hayas sido invitado a un presupuesto',
  user_profile_settings_ASSIGNED_AMOUNT_TO_BUDGET: 'Fondos asignados',
  user_profile_settings_ASSIGNED_AMOUNT_TO_BUDGET_comment:
    'Te avisaremos cuando hayan asignado fondos a uno de tus presupuestos',
  user_profile_settings_WEEKLY_SUM_UP_TRANSACTION: 'Resumen semanal',
  user_profile_settings_WEEKLY_SUM_UP_TRANSACTION_comment:
    'Cada semana te avisaremos de las transacciones que has realizado y les falta información por completar',
  user_profile_settings_AUTHORIZATION_TRANSACTION: 'Autorización de compra',
  user_profile_settings_AUTHORIZATION_TRANSACTION_comment:
    'Te avisaremos cuando un comercio compruebe que tu tarjeta es válida para comprar',
  user_profile_settings_WEEKLY_PENDING_REVIEW_TRANSACTION: 'Aviso semanal de gastos pendientes de revisar',
  user_profile_settings_WEEKLY_PENDING_REVIEW_TRANSACTION_comment: 'Cada semana te avisaremos de los gastos que tienes pendientes de revisar',

  user_profile_settings_email: 'Email',
  user_profile_settings_mobile: 'App',
  user_profile_settings_language: 'Idioma de la web',
  user_settings_language__spanish: 'Español',
  user_settings_language__english: 'Inglés',
  user_settings_language__portuguese: 'Portugués',

  user_post_settings_notification_success:
    'Se han actualizado las preferencias correctamente',
  user_post_settings_notification_error:
    '¡Ups! Algo ha ido mal al intentar actualizar las preferencias',
  /* - SnackBars Users Messages - */
  customer_action_create_customer_success:
    'Hemos enviado la invitación al cliente',
  customer_action_create_customer_error:
    '¡Ups! Algo ha ido mal al invitar a este cliente',
  customer_action_fetch_customers_error:
    '¡Ups! Algo ha ido mal al pedir el listado de clientes',
  customer_action_update_customer_success:
    'Hemos actualizado la información del cliente satisfactoriamente',
  customer_action_update_customer_error:
    '¡Ups! Algo ha ido mal al actualizar la información del cliente',
  customer_action_archive_customer_success:
    'Hemos archivado al cliente satisfactoriamente',
  customer_action_archive_customer_error:
    '¡Ups! Algo ha ido mal al intentar archivar este cliente',
  customer_action_activate_customer_success:
    'Hemos activado al cliente satisfactoriamente',
  customer_action_activate_customer_error:
    '¡Ups! Algo ha ido mal al intentar activar a este cliente',
  users_action_fetch_users_error:
    '¡Ups! Algo ha ido mal al pedir el listado de usuarios',
  users_actions_update_user_success:
    'La información del usuario se ha actualizado',
  users_actions_update_user_error:
    '¡Ups! Algo ha ido mal al actualizar la información del usuario',
  users_actions_update_user_online_payment_true: 'Los pagos online se han habilitado para este usuario',
  users_actions_update_user_online_payment_false: 'Los pagos online se han bloqueado para este usuario',
  users_actions_send_invitations_success:
    'Se han enviado las invitaciones a los usuarios indicados satisfactoriamente',
  users_actions_send_invitations_error:
    '¡Ups! Algo ha ido mal al intentar enviar las invitaciones a los usuarios',
  users_actions_activate_user_succes:
    'El usuario ha sido activado satisfactoriamente',
  users_actions_activate_user_error:
    '¡Ups! Algo ha ido mal al intentar activar al usuario',
  users_actions_archive_user_success:
    'El usuario ha sido archivado satisfactoriamente',
  users_actions_archive_user_error:
    '¡Ups! Algo ha ido mal al intentar activar a este usuario',
  users_actions_fetch_user_budgets_error:
    '¡Ups! Algo ha ido mal al obtener el listado de presupuestos del usuario',

  /* User Actions Modal */
  user_action_cancel_invitation: 'Cancelar invitación',
  user_actions_modal_header: 'Detalles',
  user_actions_modal_information: 'Información',
  user_actions_modal_settings: 'Ajustes',
  user_actions_modal_user_actions: 'Acciones de usuario',
  user_actions_modal_card_actions: 'Acciones de tarjeta',
  user_actions_modal_online_payments: 'Pagos online',
  user_actions_modal_online_payments_description: 'Activa esta opción para permitir al empleado hacer pagos en comercios online.',
  users_action_cancel_user_invitation_success:
    'Hemos eliminado la cuenta del usuario correctamente',
  users_actions_cancel_user_invitation_error:
    '¡Ups! Algo ha ido mal al intentar cancelar la invitación del usuario',
  users_action_reinvite_user_success: 'Hemos reenviado el email de invitación correctamente',
  users_action_reinvite_user_error: '¡Ups! Algo ha ido mal al reenviar el email de invitación del usuario',
  users_actions_confirm_modal_message:
    'Vas a {action}  usuario {user} - <{email}> , esta acción no se puede deshacer.',
  user_action_remove_warning: 'borrar al',
  user_action_cancel_invitation_warning: 'cancelar la invitación del',
  users_confirm_cancel_invitation_header: 'Borrar invitación',
  users_confirm_remove_user_header: 'Borrar usuario',
  users_confirm_cancel_invitation_confirm_action: 'Eliminar',
  /* --- */

  /* --- Users Salary --- */
  user_request_gross_salary_title: 'Indica el salario del usuario',
  user_request_gross_salary_message:
    'Para continuar necesitamos que indiques el salario bruto anual del empleado',
  user_gross_salary: 'Salario bruto anual',
  user_request_gross_salary_error_validation_message:
    'El salario mínimo para retribución flexible debe ser de {minimumSalary}.',

  /* -------- */

  /* User Finder Selector */
  user_finder_selector_type_to_find: 'Teclea para buscar usuarios',
  user_finder_selector_select_member: 'Añadir Usuario',
  user_finder_selector_no_results: 'Sin resultados, prueba de nuevo',
  /* ------- */
  /* -------------------------------- */

  /* -- TRANSACTIONS SECTION -- */

  transactions_transactions_section_header: 'Transacciones',
  transactions_transactions_subsection_charged: 'Cargadas',
  transactions_transactions_subsections_declined: 'Denegadas',
  transactions_transactions_subsections_authorizations: 'Autorizaciones',
  transactions_transactions_subsection_pending: 'Pendientes',
  transactions_transactions_subsections_history: 'Historial',
  transactions_actions_add_expense: 'Añadir gasto',
  transactions_actions_create_expense: 'Gasto',
  transactions_actions_create_reimbursement: 'Reembolso',
  transactions_actions_create_mileage: 'Kilometraje',
  transactions_actions_create_diet: 'Dieta',
  transactions_action_export: 'Exportar',
  transactions_action_download: 'Descargar',

  transactions_action_close_accounting_periods: 'Cierre contable',
  transactions_action_close_accounting_periods_title: 'Confirmar cierre contable',
  transactions_status__OK: 'Cargada',
  transactions_status__KO: 'Rechazada',
  transactions_status__PENDING: 'Pendiente',
  transactions_status__REVIEWED: 'Revisada',
  transactions_status__AUTHORIZATION: 'Autorización',
  transaction_status__IS_ACCOUNTED: 'Contabilizado',
  transactions_status__PROCESSING: 'Procesando',
  transactions_categorize_status__PENDING: 'Pendiente',
  transactions_categorize_status__COMPLETED: 'Completada',
  transactions_categorize_status__ALL: 'Todas',
  transactions_categorize_status__INCOMPLETED: 'Falta info.',
  transactions_categorize_status__INCOMPLETED_large: 'Falta información',
  transactions_review_flow_step_default: 'Flujo de aprobación simple',
  transactions_review_flow_step_multilevel: 'Flujo de aprobación multinivel',
  transactions_review_flow_step_default_tooltip: 'Este es el flujo de aprobación que se usa por defecto en Fuell cuando no hay un flujo de aprobación multinivel asignado a un presupuesto.',
  transactions_payment_methods: 'Métodos de pago',
  transactions_payment_method__WIRE_TRANSFER: 'Transferencia',
  transactions_payment_method__CORPORATE_CASH: 'Efectivo de empresa',
  transactions_payment_method__CASH: 'Efectivo personal',
  transactions_payment_method__CORPORATE_CARD: 'Tarjeta de empresa',
  transactions_payment_method__PERSONAL_CARD: 'Tarjeta personal',
  transactions_card_type__MEMBER_PHYSICAL: 'Tarjeta Física',
  transactions_card_type__MEMBER_VIRTUAL: 'Tarjeta Virtual',
  transactions_card_type__BUDGET_VIRTUAL: 'Tarjeta Virtual',
  transactions_dashboard_transactions_header: 'Transacciones',
  transactions_dashboard_total_spent_header: 'Total gastado',
  transactions_dashboard_total_missing_info: ' Falta info.',
  transactions_dashboard_total_not_reviewed: 'Falta revisión',
  transactions_dashboard_total_missing_info_text:
    'Falta información',
  transactions_dashboard_total_not_reviewed_text:
    'Pendiente de revisar',
  transactions_dashboard_show_transactions: 'Mostrar transacciones',

  transactions_fetch_transactions_dashboard_error:
    '¡Ups! Algo ha ido mal al intentar obtener la información sobre tus transacciones',
  /* - Transactions explanation labels - */

  transactions_charged_section_explanation:
    'Aquí encontrarás todos los movimientos realizados por los empleados de tu empresa con sus tarjetas de Fuell.',
  transactions_charged_section_expenses_explanation:
    'Aquí encontrarás todos los movimientos que hayas efectuado con tus tarjetas de Fuell.',
  transactions_authorization_section_explanation:
    'Aquí encontrarás las autorizaciones de compra en comercios de las tarjetas de Fuell de los empleados de tu empresa.',
  transactions_authorization_section_expenses_explanation:
    'Aquí encontrarás las autorizaciones de compra en comercios de tus tarjetas de Fuell.',
  transactions_declined_section_explanation:
    'Aquí encontrarás todos los movimientos denegados que hayan sido efectuados por los empleados de tu empresa con sus tarjetas de Fuell.',
  trasnactions_declined_section_expenses_explanation:
    'Aquí encontrarás todos movimientos denegados que hayan sido efectuados con tus tarjetas de Fuell.',

  transactions_table_total_count_and_amount:
    'Mostrando {totalItems} {transactionType} por un valor de {transactionTableTotalAmount}.',
  transactions_table_total_count_and_amount_user_type: 'usuario | usuarios',
  transactions_table_total_count_and_amount_transaction_type: 'transacción | transacciones',
  transactions_table_total_count_and_amount_expense_type: 'gasto | gastos',
  /* - Transactions reimbursements  - */
  transactions_reimbursements_subsection_pending: 'Pendientes de revisión',
  transactions_reimbursements_subsection_history: 'Historial',

  /* - Transactions reimbursements explanation labels - */
  transactions_reimbursements_history_explanation:
    'Aquí encontrarás todos los gastos manuales efectuados por los empleados de tu empresa.',
  transactions_reimbursements_userId_history_explanation: 'Aquí encontrarás todos los movimientos que ha efectuado {userName}',
  transactions_reimbursements_users_history_explanation: 'Aquí encontrarás todos los movimientos que hayan efectuado los empleados',
  transactions_reimbursements_history_expenses_explanation:
    'Aquí encontrarás todos los gastos manuales que hayas efectuado.',
  transactions_reimbursements_pending_explanation:
    'Aquí encontrarás todos los gastos manuales efectuados por los empleados de tu empresa pendientes de revisar.',
  transactions_reimbursements_pending_expenses_explanation:
    'Aquí encontrarás todos los gastos manuales que hayas efectuado y que estén pendientes de revisión.',
  transactions_reimbursements_userId_pending_explanation: 'Aquí encontrarás todos los movimientos que ha efectuado {userName}',
  transactions_reimbursements_users_pending_explanation: 'Aquí encontrarás todos los movimientos que hayan efectuado los empleados',
  /* - Charged Transactions - */
  transactions_charged_table_header_status: 'Estado',
  transactions_charged_table_header_date: 'Fecha',
  transactions_charged_table_header_creation_date: 'Fecha de creación',
  transactions_charged_table_header_user: 'Usuario',
  transactions_charged_table_header_processing_transactions: 'Transacciones en proceso',
  transactions_charged_table_header_merchant: 'Comercio',
  transactions_charged_table_header_budget: 'Presupuesto',
  transactions_charged_table_header_card: 'Medio de pago',
  transactions_charged_table_header_card_id: 'Identificador',
  transactions_charged_table_header_amount: 'Cantidad',
  transactions_charged_table_header_receipt: 'Recibo',
  transactions_budget_not_funds_enough: 'Fondos insuficientes',
  transactions_charged_table_header_receipt_number: 'Nº recibo',
  transactions_charged_table_header_category: 'Categoría',
  transactions_charged_table_header_subcategory: 'Subcategoría',
  transactions_charged_table_header_expense_date: 'Fecha de gasto',
  transactions_charged_table_header_reviewed_date: 'Fecha de aprobación',
  transactions_charged_table_header_provider: 'Razón social',
  transactions_charged_table_header_provider_data: 'CIF',
  transactions_charged_table_header_reimbursable: 'Reembolsable',
  transactions_charged_table_header_no_reimbursable: 'No reembolsable',
  transactions_charged_table_header_total: 'Total',

  cards_table_header_status: 'Estado',
  cards_table_header_user: 'Usuario',
  cards_table_header_budget: 'Presupuesto',
  cards_table_header_card_id: 'Identificador',
  cards_table_header_name: 'Nombre',
  // RF only
  transactions_table_activity_group_category: 'Categoría',
  /* Transaction Export filters */
  transactions_export_budgets_selector_label: 'Seleccionar presupuesto de exportación',
  transactions_export_cards_selector_label: 'Seleccionar tarjeta de exportación',
  transactions_export_reference_date: 'Fecha de referencia',
  transactions_export_reference_date_description: 'Seleccione la fecha de los gastos a considerar para hacer la exportación',
  transactions_export_creation_date: 'Fecha de creación',
  transactions_export_expense_date: 'Fecha del gasto',
  transactions_export_confirmation_date: 'Fecha valor',
  transactions_export_approve_date: 'Fecha de aprobación',
  transactions_export_without_date: 'Sin fecha',
  transactions_export_file_format: 'Formato de archivo',
  transactions_export_file_format_description: 'Seleccione el tipo de formato en el que realizar la exportación',
  transactions_export_date_range_selector_label:
    'Rango de fechas',
  transactions_export_date_range_selector_placeholder: 'Selecciona el rango de fechas',
  transactions_export_info:
    'Introduce el rango de fechas, así como los filtros que desees. Si introduces un correo, te avisaremos cuando la descarga esté disponible, si no, podrás comprobar y realizar la descarga en la pestaña "Mis exportaciones"',
  transactions_export_email_to_notify: 'Correo al que mandar el aviso',
  transactions_export_action_export_and_lock:
    'Bloquear transacciones exportadas para que no puedan ser modificadas.',
  transactions_export_action_export_and_lock_help:
    'Podrás desbloquearlas, una a una, más adelante.',
  transactions_export_holded_config_not_present:
    'Para exportar en este formato es necesario configurar la integración con Holded, {navigationLink} si no lo has hecho',
  transactions_export_holded_config_click_here: 'pincha aquí',
  transactions_export_default_format: 'Formato normal',
  transactions_export_default_users_format:
    'Formato normal desglosado por usuarios',
  transactions_export_holded_format:
    'Formato para Holded (versión beta, en pruebas)',
  transactions_export_navision_format:
    'Formato para Navision (versión beta, en pruebas)',
  transactions_export_plexus_format: 'Formato específico para Plexus',
  transactions_export_plexus_with_tickets_format: 'Formato específico para Plexus (con tickets)',
  transactions_export_plexus_without_tickets_format: 'Formato específico para Plexus (sin tickets)',
  transactions_export_twentyfour_seven_categories_format: 'Formato producción por categorías',
  transactions_export_wrap_file_format: 'Formato Wrap File',
  transactions_export_smile_file_format: 'Formato específico para Smile Company',
  transactions_export_talleres_garrido_format: 'Formato específico para Talleres Garrido',
  transactions_export_tecnocarrocera_format: 'Formato específico para Tecnocarrocera',
  transactions_export_rosa_gres_catalonia_ceramica_format: 'Exportación para contabilidad',
  transactions_export_custom_mapping_format: 'Archivo personalizado',

  transactions_export_tab_export_settings: 'Configurar exportación',
  transactions_export_tab_download_settings: 'Configurar descarga',
  transactions_export_tab_export_history: 'Mis exportaciones',
  transactions_export_tab_download_history: 'Mis descargas',
  transactions_export_modal_export_users_explanation:
    'Verás la información exportada desglosada por los usuarios de tu empresa.',

  transactions_export_success:
    'Se está procesando tu exportación, si lo has indicado, te enviaremos un aviso al correo cuando esté disponible',
  transactions_export_error:
    '¡Ups! Hemos tenido un problema al solicitar la exportación',
  transactions_export_request_export: 'Solicitar exportación',
  transactions_export_request_download: 'Solicitar descarga',

  /* Transaction export history */
  transactions_export_history_table_header_export_date: 'Fecha de solicitud',
  transactions_export_history_table_header_export_type:
    'Formato de exportación',
  transactions_export_history_table_header_export_status: 'Estado',
  transactions_export_history_table_header_export_download: 'Descargar',
  transactions_export_history_download_in_progress: 'Generando descarga...',
  transactions_export_history_type__NORMAL: 'Normal',
  transactions_export_history_type__COMPLETE: 'Por usuarios',
  transactions_export_history_type__HOLDED: 'Holded',
  transactions_export_history_type__NAVISION: 'Navision',
  transactions_export_history_type__BUDGETS: 'Presupuesto/{budget}',
  transactions_export_history_type__PHYSICAL_CARDS: 'Tarjeta/{card}',
  transactions_export_history_type__VIRTUAL_CARDS: 'Tarjeta/{card}',
  transactions_export_history_type__EXPENSES_TRANSACTIONS: 'Mis gastos/Transacciones',
  transactions_export_history_type__EXPENSES_REFUNDS: 'Mis gastos/Gastos',
  transactions_export_history_status__PENDING: 'En cola para procesar',
  transactions_export_history_status__PROCESSING: 'Procesando...',
  transactions_export_history_status__COMPLETE: 'Lista para descargar',
  transactions_export_history_status__ERROR: 'Error al exportar',
  transactions_export_history_type__PLEXUS: 'Plexus',
  transactions_export_history_type__PLEXUS_WITHOUT_TICKETS: 'Plexus sin tickets',
  transactions_export_history_type__CUSTOM_WITHOUT_HISTORY: 'Archivo personalizado',
  transactions_export_history_type__CUSTOM: 'Archivo personalizado',
  transactions_export_history_type__CATEGORIES_BY_USER: 'Producción por categorías',
  transactions_export_history_type__WRAP_FILE: 'Formato WRAPFILE',
  transactions_export_history_type__SMILE: 'Formato SMILE',
  transactions_export_history_type__ROSA_GRES: 'Exportación para contabilidad',
  transactions_export_history_type__NORMAL_BUDGETS: 'Normal/{budget}',
  transactions_export_history_type__COMPLETE_BUDGETS: 'Por usuarios/{budget}',
  transactions_export_history_type__HOLDED_BUDGETS: 'Holded/{budget}',
  transactions_export_history_type__NAVISION_BUDGETS: 'Navision/{budget}',
  transactions_export_history_type__BUDGETS_BUDGETS: 'Presupuesto/{budget}',

  transactions_export_history_type__CATEGORIES_BY_USER_BUDGETS: 'Producción por categorías/{budget}',
  transactions_export_history_type__WRAP_FILE_BUDGETS: 'Formato WRAPFILE/{budget}',
  transactions_export_history_type__SMILE_BUDGETS: 'Formato SMILE/{budget}',

  /* - Transactions Snackbar Messages  - */
  transactions_fetch_transactions_error:
    '¡Ups! Algo ha ido mal al pedir la lista de transacciones',
  transactions_fetch_transaction_error:
    '¡Ups! Algo ha ido mal al pedir la información de esta transacción',
  transactions_put_transaction_resource_error:
    '¡Ups! Algo ha ido mal al intentar subir el recibo para esta transacción',
  transaction_edit_transaccion_success:
    'Transaccion actualizada satisfactoriamente',
  transaction_put_transaction_error:
    '¡Ups! Algo ha ido mal al editar la información de la transacción',
  transactions_export_transactions_error:
    '¡Ups! Algo h ido mal al hacer la exportación de transacciones ',
  transaction_warning_AMOUNT_EXCEEDED: 'El importe de este gasto es elevado',
  transaction_warning_DUPLICATE: 'Gasto duplicado',
  transaction_warning_OUT_OF_ASSIGNED_TIME: 'Gasto fuera de horario',
  transaction_warning_WITHOUT_TICKET: 'Gasto sin recibo',
  transaction_warning_AMOUNT_DISTINCT_OCR: 'Nuestro OCR ha leído un importe diferente en el recibo al que aparece en el gasto',
  transaction_warning_DISTANCE_CUSTOM_WRONG: 'Distancia modificada a mano',
  transaction_warning_DISTANCE_MANUAL: 'Distancia añadida a mano porque no se ha podido calcular.',
  transaction_warning_AMOUNT_DISTINCT_SUM_TAXES: 'Las cuantías indicadas no coinciden con el monto total',
  transaction_warning_duplicate_text: 'Gasto {index}',
  transaction_warning_duplicate_link: 'Ir al gasto',
  transaction_warning_duplicate_tooltip: 'Hemos detectado que los gastos del listado tienen el mismo recibo asociado. Puedes revisarlo siguiendo el enlace a cada gasto.',
  transaction_warning_ignore: 'Ignorar',
  transaction_warning_ignore_modal: 'Ignorar alerta',
  transaction_warning_ignore_message: '¿Estás seguro de ignorar la alerta? Esta acción no se puede deshacer',
  transaction_close_delete_draft: 'Guardar borrador',
  transaction_close_delete: 'Eliminar gasto',
  transaction_close_without_save: 'Salir sin guardar',
  transaction_close_without_save_description: '¿Estás seguro de querer salir sin guardar el gasto?',
  /* - Edit Transaction Modal - */
  transactions_edit_original_amount: 'Cantidad original',
  transactions_edit_exchange_rate: 'Tasa de cambio',
  transactions_edit_transaction_modal_header: 'Detalles de transacción',
  transactions_edit_reimbursement_modal_header: 'Detalles del gasto',
  transactions_edit_diet_modal_header: 'Detalles de dieta',
  transactions_edit_mileage_modal_header: 'Detalles del kilometraje',
  transactions_edit_transaction_required_fields: 'Campos Requeridos',
  transactions_edit_transaction_optional_fields: 'Campos Opcionales',
  transactions_edit_transaction_notes_field: 'Notas',
  transactions_edit_transaction_save: 'Guardar cambios',
  transaction_edit_receipt_number: 'Nº de recibo',
  transactions_edit_no_resources: 'No se han subido archivos',
  transaction_edit_receipt: 'Recibos',
  trasaction_detail_empty_receipt: 'Recibo pendiente de asociar',
  trasaction_detail_without_receipt: 'Sin recibo',
  transaction_edit_bill_type: 'Factura o recibo',
  transaction_edit_receipt_available: 'Recibos disponibles',
  transactions_edit_transaction_category: 'Categoría',
  transactions_edit_transaction_subcategory: 'Subcategoría',
  transactions_edit_transaction_payment_method: 'Método de pago',
  transactions_edit_transactions_custom_category: 'Subcategoría',
  transactions_edit_transaction_tax_region_selector: 'Región de tributación',
  transactions_edit_transaction_amount: 'Cantidad',
  transactions_edit_transaction_date: 'Fecha',
  transactions_edit_transaction_merchant: 'Comercio',
  transactions_edit_transaction_budget: 'Presupuesto',
  transaction_data: 'Datos de la transacción',
  reimbursement_data: 'Datos del gasto',
  mileage_data: 'Datos del kilometraje',
  diet_data: 'Datos de la dieta',
  transaction_tax_data: 'Datos fiscales',
  transactions_edit_receipt_number: 'Nº de recibo',
  transactions_edit_company_name: 'Razón social',
  transactions_edit_identity_number: 'CIF',
  transactions_edit_tax_region: 'Región de tributación',
  transactions_edit_taxes: 'Base imponible',
  transaction_edit_address_address: 'Calle',
  transaction_edit_ocr_receipt: 'OCR (Recibo {index})',
  transaction_edit_address: 'Dirección',
  transaction_edit_zip_code: 'Código postal',
  transaction_edit_city: 'Ciudad',
  transaction_edit_state: 'Provincia',
  transaction_edit_country: 'País',
  transactions_edit_transaction_resources_amount:
    '{resourcesAmount} archivo subido | {resourcesAmount} archivos subidos',
  transaction_without_receipt_modal_title: 'No tengo recibo',
  transaction_without_receipt_modal_message: 'Puedes editar la nota o añadir un recibo si lo precisas',
  transaction_without_receipt_edit_note: 'Editar nota',
  categories_action_fetch_categories_error:
    '¡Ups! Algo ha ido mal al obtener el listado de categorias',
  transactions_fetch_vat_types_error:
    '¡Ups! Algo ha ido mal al obtener el listado de regiones tributarias',
  transactions_remove_transaction_success:
    'Se ha eliminado la transacción correctamente',
  transactions_remove_transaction_error:
    '¡Ups! Hemos tenido un problema al intentar eliminar la transacción',
  transactions_fetch_budget_custom_field_error: '¡Ups! hemos tenido un problema al intentar obtener los campos personalizados del presupuesto',
  /* - Transaction Receipt Modal and Expenses Receipts modal- */
  transactions_receipt_modal_header: 'Recibos de transacción',
  expense_modal_information_label:
    '¿Has pagado un gasto corporativo con tu dinero? Añádelo aquí para que tu empresa te reembolse el gasto (si encaja con la política de gastos).',
  expenses_receipts_modal_header: 'Recibos de gasto',

  transactions_receipt_modal_body:
    'Estos son los recursos asociados a esta transacción',
  expenses_receipt_modal_body:
    'Estos son los recursos que se asociarán al gasto',

  transactions_receipt_modal_body_zero_results:
    'No hay recursos asociados a esta transacción',
  expenses_receipt_modal_body_zero_results: 'No hay recibos para este gasto',
  transactions_edit_cif_field: 'CIF',
  transactions_edit_social_reason_field: 'Razón social',
  transactions_edit_tax_base: 'Base imponible',
  transactions_edit_quota: 'Cuota',
  transactions_transaction_edit_lock_transaction: 'Bloquear transacción',
  transaction_dont_have_receipt: 'No tengo recibo',
  transactions_transaction_edit_review_transaction: 'Marcar como revisada',
  transaction_edit_transaction_lock_warning:
    'Estás a punto de cerrar esta transacción, una vez bloqueada no podrás modificarla. ¿Quieres continuar?',
  transaction_edit_transaction_lock_warning_incomplete_transaction:
    'A esta transacción le falta información por completar y si la cierras no podrás modificarla. ¿Quieres continuar?',
  transaction_edit_locked_transaction_label: 'Cerrada el {date} por {user} ',
  transactions_processing_tooltip_label: 'Estamos procesando la acción. Podrás hacer cambios cuando terminemos.',
  transaction_review_tooltip_label: 'Revisada por {0} {1} el {2}',
  transaction_accounted_tooltip_label: 'Contabilizada por {0} {1} el {2}',
  transaction_lock_tooltip_label: 'Bloqueada por {0} {1} el {2}',
  transaction_lock_accounting_period: 'Bloqueada por cierre contable de {0}',

  transaction_dont_send_to_devoluiva:
    'No quiero solicitar factura con IVA de este gasto',

  transaction_dont_send_to_devoluiva_error:
    '¡Ups! Hemos tenido un problema al cambiar la información de la transacción',
  transaction_is_locked_error: 'Esta transacción está bloqueada',
  transaction_upload_receipt_invalid_mimetype:
    'Formato de recibos inválido, recuerda que puedes subir imágenes y archivos PDF',
  transaction_delete_transaction: 'Borrar transacción',
  transaction_delete_expense: 'Borrar gasto',
  transaction_delete_mileage: 'Borrar kilometraje',
  transaction_delete_diet: 'Borrar dieta',

  transactions_lock_transaction_success:
    'Transacción bloqueada satisfactoriamente',
  transactions_unlock_transaction_success:
    'Transacción desbloqueada satisfactoriamente',
  transactions_review_transaction_success:
    'Transacción marcada como revisada satisfactoriamente',
  transactions_unreview_transaction_success:
    'Transacción marcada sin revisar satisfactoriamente',
  transactions_review_selected_users_success: 'Transacciones marcadas como revisada satisfactoriamente',
  transactions_review_selected_users_error: '¡Ups! Hemos tenido un problema al marcar la revisión de las transacciónes',

  transactions_edit_transaction_success:
    ' Transacción guardada satisfactoriamente',
  transactions_lock_transaction_error:
    '¡Ups! Hemos tenido un problema al revisar el bloqueo la transacción',
  transactions_review_transaction_error:
    '¡Ups! Hemos tenido un problema al marcar la revisión de la transacción',
  transaction_is_locked_message:
    'La transacción está bloqueada y no pueden hacerse cambios',
  transactions_receipt_type_RECEIPT: 'Recibo',
  transactions_receipt_type_BILL: 'Factura',
  transactions_receipt_type_change_RECEIPT: 'Marcar como recibo',
  transactions_receipt_type_change_BILL: 'Marcar como factura',
  transactions_receipt_processing: 'Leyendo',
  transactions_receipt_signed_date: 'Documento firmado el día {signedCreatedAt}',

  transactions_receipt_type_change_question: '¿Estás seguro de querer cambiar el tipo de recibo?',
  transactions_choose_receipt_type: 'Seleccione si el archivo es un recibo o una factura',
  transactions_choose_receipt_type_disclaimer: 'Los gastos subidos mediante este método no están firmados por Fuell y no cuentan con certificación homologada. Si has recibido este documento por medios digitales no requiere de certificación si su contenido no ha sido alterado y si provienen de una fuente fiable. {clickHereSlot}',
  transactions_choose_receipt_type_disclaimer_click_here: 'Mais informações aqui',
  transaction_upload_in_progress_title: '¡Nuestro OCR está en marcha!',
  transaction_upload_in_progress_description: 'Estamos leyendo tu recibo, puedes salirte del gasto sin problema. Ya nos encargamos nosotros de completar los datos.',
  transaction_upload_in_progress_understood: 'Entendido',
  /* - Transactions filters */
  transactions_filter_transaction_status: 'Estado',
  transactions_filter_is_bill_all: 'Todo',
  transactions_filter_transaction_tax_type: 'IVA',
  transactions_filter_tax_types_all: 'Todos',
  transactions_filter_is_bill_only_bills: 'Facturas',
  transactions_filter_is_bill_only_receipts: 'Recibos',
  transactions_filter_transaction_accounting_period:
    'Periodo de cierre contable',
  transactions_filter_transaction_is_bill: 'Recibos o facturas',
  transactions_filter_budgets_search: 'Teclea para buscar presupuestos',
  transactions_filter_customer: 'Empresas',
  transactions_filter_customer_search: 'Buscar empresas',
  transactions_filter_user_search: 'Teclea para buscar usuarios',
  transactions_filter_transaction_review_status: 'Revisadas o no revisadas',
  transactions_review_status__ALL: 'Todas',
  transactions_review_status__REVIEWED: 'Revisadas',
  transactions_review_status__NOT_REVIEWED: 'No revisadas',
  transactions_filter_transaction_personal_expense: 'Gasto personal',
  transactions_review_status__PERSONAL_EXPENSE: 'Gasto Personal',

  transactions_filter_transaction_warning: 'Avisos',
  transactions_filter_transaction_account: 'Contabilización',
  transactions_filter_transaction_account_ALL: 'Todas',
  transactions_filter_transaction_account_ACCOUNTED: 'Contabilizadas',
  transactions_filter_transaction_account_UNACCOUNTED: 'No contabilizadas',
  transaction_discounting: 'Descontabilizar',
  transaction_account: 'Contabilizar',
  transactions_warning__ALL: 'Todas',
  transactions_warning__WITH_WARNINGS: 'Con avisos',
  transactions_review_status__NO_WARNINGS: 'Sin avisos',
  transactions_filter_review_status: 'Estado de revisión',
  transactions_filter_review_status_placeholder: 'Filtrar por estado de revisión',
  transactions_filter_review_status_placeholder_check_selected_filters: 'Ver filtros aplicados',
  transactions_filter_review_status_flow_header_reviewed: 'Revisadas',
  transactions_filter_review_status_flow_option_approved: 'Aprobadas',
  transactions_filter_review_status_flow_option_rejected: 'Rechazadas',
  transactions_filter_review_status_flow_option_personal_expense: 'Gasto personal',
  transactions_filter_review_status_flow_list_header_in_review: 'En revisión',
  transactions_filter_create_filtered_view: 'Crear una {filteredViewSlot} con los filtros seleccionados',
  transactions_filter_create_filtered_view_slot: 'vista predeterminada',
  transactions_filter_create_filtered_view_modal_header: 'Crear vista predeterminada',
  transactions_filter_create_filtered_view_modal_info: 'Dale un nombre a la vista predeterminada para que sea más sencillo utilizarla',
  transactions_filter_create_filtered_view_modal_placeholder: 'Nombre de la vista',
  transactions_filter_create_filtered_view_modal_action_confirm: 'Crear vista',
  transactions_filter_quick_filter_dropdown_action_edit: 'Editar vista',
  transactions_filter_quick_filter_dropdown_action_remove: 'Eliminar vista',
  transactions_filter_remove_quick_filter_modal_header: 'Eliminar vista',
  transactions_filter_remove_quick_filter_modal_confirm_action: 'Eliminar',
  transactions_filter_remove_quick_filter_modal_info: '¿Estás seguro de eliminar la vista? Esta acción no se puede deshacer',
  transactions_filter_quick_filter_save_as_new_quick_filter_action: 'Guardar como nueva vista predeterminada',
  transaction_filter_quick_filter_edit_quick_filter: 'Editar vista',
  transactions_filter_by_date: 'Filtrar por fecha',
  transactions_filter_budgets_show_archived_option: 'Mostrar archivados',
  transactions_filter_users_show_deleted_option: 'Mostrar borrados',
  transactions_filter_users_deleted_user: 'Borrado',

  /* ------ */
  /* - My Expenses - */
  transactions_my_expenses_reimbursements: 'Mis gastos',
  transactions_my_expenses_transactions: 'Mis transacciones',
  /* --- */
  /* -- REVIEW FUNNEL -- */
  transactions_funnel_actions_send_for_review: 'Pedir revisión',
  transactions_funnel_update_status_transition_not_allowed:
    'No es posible modificar al estado de revisión de destino',
  transactions_change_funnel_status_success:
    'Se ha actualizado el estado de revisión correctamente',
  transactions_change_review_status_error:
    '¡Ups! Hemos tenido un problema al intentar cambiar el estado de revisión',
  transactions_funnel_reject_reason_modal_title: 'Añadir nota',
  transactions_funnel_reject_reason_modal_message:
    'Añade una nota para explicar por qué se ha rechazado el gasto',
  transactions_funnel_reject_reason_modal_placeholder: 'Añadir una nota',
  transactions_funnel_reject_reason_modal_validation_error: 'Para rechazar el gasto es necesario escribir una nota explicativa',
  transactions_funnel_reject_reason_close_modal_title: 'Cerrar modal',
  transactions_funnel_reject_reason_close_modal_warning: 'Si cierras esta ventana no se completará la acción de rechazar gasto. ¿Estás seguro de cerrar la ventana?',
  transactions_funnel_reject_reason_close_modal_warning_confirm_close: 'Cerrar igualmente',
  transactions_funnel_reject_reason_close_modal_warning_add_note: 'Añadir comentario',
  transaction_funnel_reject_reason: 'Motivo de rechazo',
  transaction_expense_rejected_label: 'Motivo de rechazo: {reviewRejectReason}',
  transactions_not_receipt_reason_modal_message: 'Añade una nota para explicar el motivo por el que falta el recibo',
  transactions_not_receipt_reason_modal_placeholder: 'Motivo de la falta de recibo',
  transactions_funnel_reject_reason_add_note_modal_title: 'Añadir comentario',
  transactions_funnel_reject_reason_add_note_modal_message: 'Añade el comentario que quieras que vean los revisores de los siguientes pasos',
  transactions_funnel_reject_reason_add_note_close_modal_warning: 'Si cierras esta ventana no se completará la acción de {actionName}. ¿Estás seguro de cerrar la ventana?',
  transaction_funnel_comment_action_modal_action_approve: 'aprobar con comentario',
  transaction_funnel_comment_action_modal_action_mark_as_personal: 'marcar como personal con comentario',
  transaction_funnel_comment_action_modal_action_reject: 'rechazar gasto',

  transactions_review_status__DRAFT: 'Borrador',
  transactions_review_status_send_for_review: 'En revisión',
  transactions_review_status__AWAITING_REVIEW: 'Pendiente de revisión',
  transactions_review_status__APPROVED: 'Aprobado',
  transactions_review_status__CANCELLED: 'Rechazado',
  transactions_review_status__CREATED: 'Gasto creado',
  transactions_review_status__OFFICE_FLOW_REVISION: 'En revisión',
  transactions_review_status__NOT_VALID: 'No validado',
  transactions_review_status__VALID: 'Validado',
  transactions_status_processing: 'Gasto retenido',
  transactions_detail_review_log_header: 'Historial',
  transactions_review_status_log_check_history: 'Ver historial',
  transactions_review_status_log_sent_for_review: 'Enviado a revisión',
  transactions_review_status_log_reviewed: 'Revisado',
  transactions_funnel_actions_review: 'Revisar',
  transactions_funnel_actions_unreview: 'No revisar',
  transactions_funnel_actions_lock: 'Bloquear',
  transactions_funnel_actions_unlock: 'Desbloquear',
  transactions_funnel_actions_account: 'Contabilizar',

  transactions_funnel_actions_approve: 'Aprobar',
  transactions_funnel_actions_approve_with_comments: 'Aprobar con comentario',
  transactions_funnel_actions_approve_undo: 'Desaprobar',
  transactions_funnel_actions_reject: 'Rechazar',
  transactions_funnel_actions_undo: 'Deshacer',
  transactions_funnel_actions_mark_as_personal: 'Gasto personal',
  transactions_funnel_actions_mark_as_personal_with_comments: 'Gasto personal con comentario',
  transactions_funnel_actions_unmark_as_personal: 'Desmarcar gasto personal',
  transactions_funnel_actions_apply_changes: 'Aplicar',
  transactions_status_personal_expense: 'Gasto personal',
  transaction_taxes_error: 'Las cuantías indicadas no coinciden con el monto del gasto',
  /* --- */
  /* -- Multiple transactions keys */
  transactions_review_selected_transactions_success:
    'Se han marcado las transacciones como revisadas correctamente',
  transactions_review_selected_transactions_error:
    '¡Ups! Hemos tenido un problema al marcar las transacciones como revisadas',
  transactions_unreview_selected_transactions_success:
    'Se han marcado las transacciones como no revisadas correctamente',
  transactions_unreview_selected_transactions_error:
    '¡Ups! Hemos tenido un problema al marcar las transacciones como no revisadas',
  transactions_account_selected_transactions_success: 'Se han marcado las transacciones como contabilizadas correctamente',
  transactions_account_selected_transactions_error:
    '¡Ups! Hemos tenido un problema al marcar las transacciones como contabilizadas',
  transactions_reject_selected_transactions_success:
    'Se han marcado las trasnsacciones como rechadas correctamente',
  transactions_reject_selected_transactions_error:
    '¡Ups! Hemos tenido un problema al marcar las transacciones como rechazadas',
  transactions_mark_as_review: 'Marcar como revisada',
  transactions_mark_as_review_in_progress: 'Marcando como revisadas...',
  transactions_mark_as_unreview_in_progress: 'Quitando marca de revisadas...',
  transactions_mark_as_unreviewed: 'Quitar marca de revisada',
  transactions_total_transactions_selected:
    'Has seleccionado {selectedTransactions} {transactionType}',
  transactions_total_users_selected:
    'Has seleccionado los gastos de {selectedUsers} usuario(s)',
  transactions_confirm_mark_selected_transactions_as_reviewed:
    'Marcar transacciones como revisadas',
  transactions_confirm_mark_selected_transactions_as_unreviewed:
    'Marcar transacciones como no revisadas',
  transactions_multiple_transactions_selected_to_review:
    'Has seleccionado {transactionsAmount} transaccione(s) para marcar como revisadas, pulsa Sí para continuar o pulsa No para volver',
  transactions_multiple_transactions_selected_to_unreview:
    'Has seleccionado {transactionsAmount} transaccione(s) para marcar como no revisadas, pulsa Sí para continuar o pulsa No para volver',
  transactions_multiple_transactions_action_confirm:
    'Se modificarán {transactionsTotalItems} transacciones. ¿Continuar?',
  transactions_total_transactions_bulk_selection:
    'Has seleccionado las {selectedTransactions} transaccion(es) cargadas de {transactionsTotalItems} totales. ',
  transactions_total_transactions_bulk_selection_all:
    'Has seleccionado las {transactionsTotalItems} transacciones existentes. ',
  transactions_total_transactions_bulk_selection_action_select: 'Seleccionar las {transactionsTotalItems} transacciones realizadas',
  transactions_total_transactions_bulk_selection_action_cancel_select:
    'Deshacer selección',
  transactions_multiple_users_action_title: 'Aprobar gastos',
  transactions_multiple_users_action_confirm: '¿Estás seguro de aprobar estos gastos?',
  transactions_bulk_action_warning_errors:
    'Se ha realizado la acción con algunos errores, te hemos cargado las que han fallado',
  transactions_bulk_action_no_context_error:
    'Hay transacciones bloqueadas o en algún estado de revisión que no puede cambiar al estado elegido',
  transactions_bulk_action_invalid_budget_goal_error:
    'Hay gastos que superan el limite de algunos presupuestos:',
  transactions_bulk_action_warning_confirm: 'Has seleccionado {selectedTransactionsCount} gastos de los cuales solo se pueden {bulkAction} {validAmount} ¿Quieres continuar?',
  transactions_bulk_action_name__APPROVE: 'Revisar',
  transactions_bulk_action_name__REJECT: 'Rechazar',
  transactions_bulk_action_name__LOCK: 'Bloquear',
  transactions_bulk_action_name__UNLOCK: 'Desbloquear',
  transactions_bulk_action_name__UNREVIEW: 'Desaprobar',
  transactions_bulk_action_name__ACCOUNT: 'Contabilizar',
  /* --- */
  /*  Transactions --- Accounting periods */
  accounting_close_accounting_periods: 'Cerrar contabilidad',
  accounting_select_accounting_period_placeholder:
    'Selecciona periodo contable',
  accounting_periods_action_close_periods: 'Cerrar periodo',
  accounting_periods_closure_transaction_closure_warning:
    'Una vez se cierre un periodo, las transacciones serán bloqueadas y ya no podrán ser editadas.',
  accounting_periods_closure_transaction_closure_undo_warning:
    'Esta acción no se puede deshacer.',
  accounting_period_closure_warning:
    'Las transacciones ya no serán editables, ¿Quieres continuar?',
  accounting_period_closure_transactions_affected:
    'Tienes {amount} transacciones {action} a las que les falta información',
  accounting_period_action_click: '(click para ver)',
  accounting_closure_in_progress: 'Cerrando periodo...',
  accounting_periods_closure_success:
    'Se ha cerrado el periodo contable correctamente',
  accounting_periods_closure_error:
    '¡Ups! Hemos tenido un problema cerrando el periodo contable:',
  /* */
  /* - Transactions Misc - */
  transactions_row_file_amount: '{count} archivo | {count} archivos',
  /* -- */

  /* - Accounting - */
  accounting_action_fetch_accounting_periods_error:
    '¡Ups! Algo ha ido mal al obtener la lista de periodos contables',
  /* -  Expenses - */

  expenses_save_as_draft: 'Guardar borrador',
  expenses_send_to_review: 'Enviar a revisión',
  expenses_send_to_review_description: 'Para poder enviar el gasto a revisión hace falta añadir un recibo',
  expenses_upload_receipt: 'Subir recibo',
  expenses_expense_is_reimbursable: 'Reembolsable',
  expenses_expense_is_not_reimbursable: 'No reembolsable',
  /* - Create Expense Modal - */
  expenses_create_expense_header: 'Añadir gasto',
  expenses_create_reimbursement_header: 'Añadir gasto',
  expenses_edit_reimbursement_header: 'Detalles del gasto',
  expenses_edit_expense_header: 'Detalles del gasto',
  expense_merchant_name: 'Comercio',
  expense_payment_method: 'Método de pago',
  expense_amount: 'Cantidad',
  expense_exchange_rate: 'Tasa de cambio',
  expense_default_currency_amount: 'Cantidad en euros',
  expense_edit_expense_date: 'Fecha',
  expense_budget: 'Presupuesto',
  expense_notes: 'Notas',
  expense_budget_not_enough_funds: '- No hay fondos suficientes',

  expenses_mark_as_refund: 'Abono',

  expense_create_expense_success: 'Se ha añadido el gasto satisfactoriamente',
  expense_create_expense_error:
    '¡Ups! Hemos tenido un problema al añadir ese gasto',
  expense_edit_expense_error:
    '¡Ups! Hemos tenido un problema al editar este gasto',
  /* - Create Mileage Modal - */
  expense_create_mileage_header: 'Crear gasto de kilometraje',
  expense_edit_mileage_header: 'Editar gasto de kilometraje',
  expense_mileage_origin: 'Origen',
  expense_mileage_destination: 'Destino',
  expense_mileage_category: 'Categoría',
  expense_mileage_distance_kms: 'Distancia (en Kms)',
  expense_mileage_distance: 'Distancia',
  expense_mileage_distance_calculated: 'Distancia calculada: {kms}km',
  expense_mileage_distance_round_trip: 'Distancia (ida y vuelta)',
  expense_mileage_amount_abbr: 'Cant.',
  expense_mileage_amount: 'Cuantía',
  expenses_create_mileage_no_categories_found_admin: 'No tienes categorías de kilometraje definidas, haz {link} para definirlas',
  expense_create_mileage_no_categories_found: 'No hay categorías de kilometrajes definidas, pídele a tu administrador que las cree para continuar',
  expense_create_mileage_categories_no_options: 'No hay categorías creadas',
  expense_create_mileage_categories_no_results: 'No se han encontrado resultados',
  expense_create_mileage_round_trip_check: 'Ida y vuelta',
  expenses_create_mileage_success: 'Se ha añadido el kilometraje correctamente',
  expense_create_mileage_error:
    '¡Ups! Hemos tenido un problema al crear el kilometraje',
  expense_create_mileage_map_default:
    'Introduce y selecciona origen y destino para mostrar el mapa y calcular la distancia entre ambos puntos',
  expense_create_mileage_map_route_error_manual:
    'Ha habido un error calculando la ruta.',
  expense_create_mileage_map_route_error:
    'Ha habido un error calculando la ruta. Puedes introducir la distancia de forma manual.',
  /* - Create diet modal */
  expenses_create_diet_header: 'Crear dieta',
  expenses_edit_diet_header: 'Editar dieta',
  expenses_create_diet_label_origin: 'Origen',
  expenses_create_diet_label_to: 'A',
  expenses_create_diet_label_destination: 'Destino',
  expenses_create_diet_categories_to_apply:
    'Selecciona el número y tipo de dietas',
    expense_create_diet_category_select_diet_category_placeholder: 'Añadir dietas',
  expenses_create_diet_no_categories_found_admin:
    'No tienes categorías de dietas definidas, haz {link} para definirlas',
  expenses_create_diet_no_categories_found:
    'No hay categorías de dietas definidas, pídele a tu administrador que las cree',
  expenses_create_diet_success: ' Se ha creado la dieta correctamente',
  expense_create_diet_error:
    '¡Ups! Hemos tenido un problema al intentar crear la dieta',
  expenses_edit_diet_success: 'Se ha editado la dieta correctamente',
  expenses_edit_diet_error:
    '¡Ups! Hemos tenido un problema al intentar editar la dieta',
  expense_create_diet_define_waypoints:
    'Escribe y selecciona origen y destino para mostrar la ruta',
  expense_diet_amount_summary:
    'La cuantía de la dieta asciende a: {totalAmount}',
  expense_diet_add_destination: '+ Añadir destino',
  /* ------------------------------------------------------- */

  /* -- BUDGETS TERMS -- */
  budgets_action_fetch_budgets_error:
    '¡Ups! Algo ha ido mal al pedir la lista de presupuestos',

  budgets_tabs_active_budgets: 'Activos',
  budgets_tabs_archived_budgets: 'Archivados',
  budget_detail_expense_evolution_tab: 'Evolución de gasto',

  budget_detail_reimbursements_tab: 'Gastos',

  budgets_new_budget: 'Nuevo Presupuesto',
  budgets_add_members: 'Añadir Usuarios',
  budgets_budget_owner: 'Propietario',
  budgets_budget_member: 'Miembro',
  budgets_budget_cycle_selector: 'Periodicidad del presupuesto',
  budgets_budget_type__PUNCTUAL: 'Una Vez',
  budgets_budget_type__MONTHLY: 'Mensual',
  budgets_budget_type__DAILY: 'Diario',
  budgets_budget_type__WEEKLY: 'Semanal',
  budgets_budget_status__ARCHIVED: 'Archivado',
  budgets_budget_status__ACTIVE: 'Activo',
  budgets_budget_days_to_expiration: '{daysToExpire} días para caducar',
  budgets_budget_day_expires_today: 'Caduca hoy',
  budgets_budget_days_to_expiration_expired: 'Presupuesto Caducado',
  budgets_budget_goal_limit: 'Límite',
  budgets_budget_assigned: 'Asignado',
  budgets_budget_spent: 'Gastado',
  budget_detail_header_limit: 'Límite:',
  budget_detail_header_assigned: 'Asignado:',
  budget_detail_header_spent: 'Gastado:',
  budget_confirm_archive_budget_header_action: 'Archivar presupuesto',
  budget_confirm_archive_budget_text:
    'Estás a punto de archivar el budget {budgetName}, ésta acción no se puede deshacer, para continuar pulsa Archivar presupuesto, de lo contrario pulsa Cancelar',
  /* -- New budgets -- */
  budgets_new_budget_header: 'Detalles de presupuesto',
  budgets_new_budget_budget_name: 'Nombre Presupuesto',
  budgets_new_budget_budget_limit: 'Límite',
  budgets_new_budget_type_monthly: 'Mensual',
  budgets_new_budget_type_one_time: 'Una vez',
  budgets_budget_type__PUNCTUAL_info:
    'Establece un límite y gasta hasta que se agote. El limite no se reinicia.',
  budgets_budget_type__DAILY_info:
    'Establece un límite recurrente cada día. El límite se reinicia a las 00:00 del día siguiente',
  budgets_budget_type__WEEKLY_info:
    'Establece un límite recurrente cada 7 días. El límite se reinicia a las 00:00 del inicio de la siguiente semana',
  budgets_budget_type__MONTHLY_info:
    'Establece un límite recurrente cada mes. El límite se reinicia cada día 1.',

  budgets_new_budget_expiration: 'Caducidad',
  budgets_new_budget_owners: 'Propietarios (al menos uno)',
  budgets_new_budget_members: 'Miembros',
  budgets_new_budget_review_flow: 'Flujo de aprobación',
  budgets_new_budget_review_flow_default_flow_info: 'Este es el flujo de aprobación que se usa en Fuell cuando no se quiere asignar un flujo de aprobación multinivel. Consta de un paso de aprobación para dueños de presupuesto, administradores y contables.',
  budgets_new_budget_fuell_default_review_flow: 'Aprobación simple',
  budgets_new_budget_default_review_flow: '(por defecto)',
  budget_action_create_budget_success: 'Presupuesto creado correctamente',
  budgets_action_create_budget_error:
    '¡Ups! Algo ha ido mal al intentar crear el presupuesto',
  /* ---- */
  /* - Budget Detail - */

  budget_actions_budget_settings: 'Configurar Presupuesto',
  budget_actions_archive_budget: 'Archivar Presupuesto',
  /* - Budget Detail Members - */
  budget_detail_members_tab: 'Miembros del Presupuesto',
  budget_detail_members: 'Miembro',
  budget_detail_budget_assigned: 'Asignado',
  budget_detail_budget_spent: 'Gastado',
  budget_detail_budget_available: 'Disponible',
  budget_detail_budgter_spent_vs_available: '% Gastado vs Disponible',
  budget_user_member_owner: 'Propietario',
  budget_detail_user_not_assigned: 'Este usuario no está asignado a ningún presupuesto.',
  budget_detail_assign_user: 'Asignarle un presupuesto',
  budgets_action_update_user_assigned_budget_success:
    'Se ha actualizado la asignación del usuario correctamente',
  budgets_action_update_user_budget_success:
    'Se ha actualizado la información del usuario del presupuesto correctamente',
  budgets_action_update_user_assigned_budget_error:
    '¡Ups! Algo ha ido mal al intentar cambiar la asignación del usuario',
  budget_action_archive_budget_success:
    'Se ha archivado el presupuesto correctamente',
  budgets_action_archive_budget_error:
    '¡Ups! Algo ha ido mal al intentar archivar el presupuesto',
  budgets_update_budget_success: 'Presupuesto actualizado correctamente',
  budgets_update_budget_error:
    '¡Ups! Algo ha ido mal al intentar actualizar el presupuesto',
  budgets_update_user_assign_error: 'Tienes que introducir alguna cantidad',
  budgets_update_user_assign_greater_than_goal_error:
    'No puedes asignar una cantidad mayor al limite del presupuesto',
  budgets_update_user_assign_lower_than_spent_error:
    'No puedes asignar una cantidad menor a lo que se ha gastado',

  budget_detail_budget_spent_tooltip: 'Gastado: {spent}',
  budget_detail_budget_available_tooltip: 'Disponible: {available}',
  budget_assignation_increase_alert: 'La asignación del usuario ha sido aumentada en {reimbursementSpent} con un total asignado de {totalAssigned} de forma temporal al tener gastos manuales aprobados',
  /* - Budget Detail Transactions - */
  budget_detail_transactions_tab: 'Transacciones',

  /* - Budget Settings - */
  budget_month_goal_edit_warning:
    'Éste es el límite del presupuesto para el mes actual. Los cambios no afectarán a futuros meses',

  /* --------------------------------------- */

  /* CARD FROZEN */
  card_frozen_modal_title: 'Congelar tarjeta',
  card_frozen_modal_description: 'Si congelas la tarjeta solamente un usuario con rol administrador podrá descongelarla. ¿Estás seguro?',
  card_frozen_modal_frozen: 'Congelar',

  /* -- CARDS TERMS -- */

  cards_budget_cards_section_tab: 'Tarjetas de Presupuestos',
  cards_physical_cards_section_tab: 'Tarjetas físicas',
  cards_virtual_cards_section_tab: 'Tarjetas virtuales',
  cards_all_cards_section_tab: 'Todas',

  card_status__DISABLED: 'Desactivada',
  card_status__ACTIVE: 'Activada',
  card_status__FROZEN: 'Congelada',
  card_status__FROZEN_tooltip: 'Congelada por el usuario',
  card_status__FROZEN_BY_ADMIN: 'Congelada por un administrador',
  card_status__BLOCKED: 'Bloqueada',
  card_status__PENDING: 'Pendiente',
  card_status__CANCELLED: 'Cancelada',
  card_status_action_freeze_by_admin_card: 'Tarjeta congelada',
  card_status_action_unfreeze_card: 'Descongelar tarjeta',
  card_status_action_freeze_card: 'Congelar tarjeta',
  card_mp_identifier: 'Número MP',
  card_not_generated: 'Tarjeta no emitida',
  cards_budget_cards_explanation:
    'Para compras online y subscripciones. Los fondos son retirados del presupuesto al que están asignadas',
  cards_physical_cards_explanation:
    'Para compras en tiendas. Los fondos son retirados de la cantidad asignada al usuario',
  cards_virtual_cards_explanation:
    'Para compras online y subscripciones. Los fondos son retirados de la cantidad asignada al usuario.',
  cards_virtual_cards_creation_explanation:
    'Para añadir una tarjeta virtual utiliza nuestra app móvil.',
  cards_detail_spent: 'gastado este mes',
  cards_detail_budget: 'Presupuesto',

  card_detail_modal_overview: 'Resumen',
  card_detail_modal_transactions: 'Transacciones',

  card_action_request_passcode: 'Introduce tu clave',
  card_action_input_passcode:
    'Por seguridad, introduce tu clave para poder continuar',
  card_action_passcode_not_found: 'Clave necesaria',
  card_passcode_request_instructions:
    'Por seguridad necesitamos que configures una clave para trabajar con tus tarjetas en tu perfil para poder continuar',
  action_go_to_profile: 'Ir a mi perfil',
  cards_action_fetch_cards_error:
    '¡Ups! Algo ha ido mal al intentar obtener el listado de tarjetas',
  cards_action_activate_card_success: 'Tarjeta activada correctamente',
  cards_action_freeze_card_success: 'Tarjeta congelada correctamente',
  cards_action_activate_card_error:
    '¡Ups! Algo ha ido mal al activar la tarjeta',
  cards_action_freeze_card_error:
    '¡Ups! Algo ha ido mal al congelar la tarjeta',
  cards_action_new_card: 'Nueva Tarjeta',
  /* --- Logs Section ---- */
  logs_office_log_tab: 'Logs de Empresas',
  logs_user_log_tab: 'Logs de Usuarios',
  logs_cards_log_tab: 'Logs de Tarjetas',
  logs_webhook_log_tab: 'Logs del WebHook',
  fetch_log_error: 'Hemos tenido un problema al intentar obtener los logs: ',
  /* ------------------ */

  /* - COMPANY TERMS  --- */
  company_settings_company_details_tab: 'Detalles de empresa',
  company_settings_transaction_fields_tab: 'Ajustes de gastos',
  company_settings_expense_fields_tab: 'Kilometraje y dietas',
  company_settings_integrations: 'Integraciones',
  company_settings_export: 'Ajustes de exportación',

  /* - Company Details - */
  company_details_company_name: 'Nombre de empresa',
  company_details_company_address: 'Dirección de la empresa',
  company_details_company_zip_code: 'Código postal',
  company_details_company_city: 'Ciudad',
  company_details_company_country_state: 'País / Provincia',
  company_details_company_registration_number: 'Número de registro',
  company_details_company_change_information_message:
    '¿Quieres cambiar o actualizar algo? {0}',
  company_support_update_company_information_message:
    'Hola, me gustaría cambiar la información de mi empresa ¿Qué tengo que hacer?',
  company_details_transaction_fields_subtitle:
    'Edita y crea los diferentes campos que se muestran en los gastos y transacciones',
  company_details_default_fields_title: 'Campos y alertas',

  company_details_fields_settings_required_fields: 'Campos obligatorios',
  company_details_fields_settings_required_fields_description: 'Define los campos obligatorios de los gastos',

  company_details_fields_settings_alerts: 'Alertas',
  company_details_fields_settings_alerts_description: 'Configura las alertas por gastos duplicados o fuera de horario',

  company_details_fields_settings_payment_methods: 'Métodos de pago',
  company_details_fields_settings_payment_methods_description: 'Define los métodos de pago aceptados por tu empresa',
  company_details_fields_settings_cards_schedule: 'Horario de uso de tarjetas Fuell',
  company_details_fields_settings_company_details_fields_settings_cards_schedule_description: 'Define el horario en el que se pueden hacer pagos con la tarjeta Fuell',

  /* Categories and subcategories modal  */
  company_details_categories_and_subcategories: 'Categorías y subcategorías',
  company_details_categories_and_subcategories_description:
    'Crea categorías y subcategorías personalizadas',

  company_details_add_fields: 'Campos personalizados',
  company_details_new_field_button: 'Añadir campo',
  company_details_new_category_button: 'Crear categoría',
  company_details_new_category_title: 'Crear categoría',
  company_details_edit_category_title: 'Editar categoría',
  company_details_edit_category_action: 'Guardar cambios',
  company_details_delete_category_title: 'Borrar categoría',
  company_details_dete_category_info: '¿Estás seguro de borrar la categoría? Todas las subcategorías asociadas se eliminarán también. Esta acción no se puede deshacer',
  company_details_new_category_action_success: 'Se ha creado la categoría correctamente',
  company_details_new_category_action_error: '¡Ups! Algo ha ido mal al crear la categoría',
  company_details_new_subcategory_button: 'Añadir subcategoría',
  company_details_remove_subcategory_action: 'Borrar subcategoría',
  company_details_action_create_custom_category_success:
    'La subcategoría se ha creado correctamente',
  company_details_action_create_custom_category_error:
    'Ha ocurrido un error creando la subcategoría',
  company_details_action_update_custom_category_success:
    'La subcategoría se ha actualizado correctamente',
  company_details_action_update_custom_category_error:
    'Ha ocurrido un error actualizando la subcategoría',
  company_details_action_delete_custom_category_success:
    'La subcategoría se ha eliminado correctamente',
  company_details_action_delete_custom_category_error:
    'Ha ocurrido un error actualizando la subcategoría',
  company_details_action_update_default_category_success:
    'La categoría se ha actualizado correctamente',
  company_details_action_update_default_category_error:
    'Ha ocurrido un error actualizando la categoría',

  company_details_category_field: 'Categoría',
  company_details_subcategory_name_field: 'Nombre',
  company_details_account_number_field: 'Código',
  company_details_tax_field: 'IVA',
  company_details_confirm_modal_delete_subcategory:
    'Vas a eliminar la subcategoría {name}. Esta acción no se puede deshacer.',

  company_details_create_category_category_name: 'Nombre de la categoría',
  company_details_create_category_category_color: 'Color',

  company_details_create_category_create_category_action: 'Crear categoría',

  company_details_admin_notifications_header:
    'Notificaciones de administración',
  company_details_admin_notifications_copy:
    'Indica las direcciones de correo a las que quieres que se envien emails cuando la cuenta se esté quedando sin saldo, el disponible sea menor a los fondos asignados o cuando se realice una recarga de la cuenta mayor a 1.000€',
  company_details_notification_mails_list: 'Correos a notificar',
  company_details_notification_mails_placeholder:
    'Teclea para añadir o seleccionar un correo...',
  company_details_notification_mails_add_tag_placeholder: 'Añadir correo',
  company_details_notification_mails_selected_label:
    'Ya en lista, pulsa para borrar',
  company_details_notification_mails_invalid_mail:
    'Introduce un correo electrónico válido',
  company_details_notification_mail_submit_error:
    '¡Ups! Algo ha ido mal al intentar actualizar el listado de correos a notificar',
  company_details_company_time_zone: 'Zona horaria',

  /* - Company Fields  */
  company_transaction_fields_table_transaction_field_name_header:
    'Campo de transacción',
  company_transaction_fields_table_field_options_header: 'Opciones de campo',
  company_transaction_fields_table_budgets_header: 'Presupuestos',
  company_transaction_fields_table_include_in_transaction_type_header: 'Incluido en',
  /* Mandatory Fields Modal */
  company_required_fields_modal_header: 'Campos obligatorios',
  company_required_fields_modal_info: 'Define los campos que es necesario que los empleados completen de manera obligatoria.',
  company_required_fields_modal_form__MILEAGE: 'Kilometrajes',
  company_required_fields_modal_form__DIET: 'Dietas',
  company_required_fields_modal_form__REIMBURSEMENT: 'Gastos',
  company_required_fields_modal_form__EXPENSE: 'Gastos',
  company_required_fields_modal_form__TRANSACTION: 'Transacciones',
  company_required_fields_modal_form_field__paymentMethod: 'Método de pago',
  company_required_fields_modal_form_field__dietSteps: 'Origen y destino',
  company_required_fields_modal_form_field__dietCategoryConfigs: 'Categoría de dietas',
  company_required_fields_modal_form_field__medias: 'Recibos',
  company_required_fields_modal_form_field__budget: 'Presupuesto',
  company_required_fields_modal_form_field__notes: 'Notas',
  company_required_fields_modal_form_field__amount: 'Cantidad',
  company_required_fields_modal_form_field__mileageCategory: 'Categoría de kilometraje',
  company_required_fields_modal_form_field__origin: 'Origen',
  company_required_fields_modal_form_field__destination: 'Destino',
  company_required_fields_modal_form_field__distance: 'Distancia',
  company_required_fields_modal_form_field__roundTrip: 'Ida y vuelta',
  company_required_fields_modal_form_field__date: 'Fecha',
  company_required_fields_modal_form_field__isBill: 'Factura o recibo',
  company_required_fields_modal_form_field__provider: 'Comercio',
  company_required_fields_modal_form_field__transaction_provider: 'Razón social',
  company_required_fields_modal_form_field__defaultCategory: 'Categoría',
  company_required_fields_modal_form_field__providerData: 'CIF',
  company_required_fields_modal_form_field__receiptNumber: 'Número de recibo',
  company_required_fields_modal_form_field__vatTypeAssigned: 'Región de tributación',
  company_required_fields_modal_form_field__country: 'País',
  company_required_fields_modal_form_field__state: 'Provincia',
  company_required_fields_modal_form_field__zipCode: 'Código postal',
  company_required_fields_modal_form_field__city: 'Ciudad',
  company_required_fields_modal_form_field__address: 'Dirección',
  company_required_fields_modal_form_field__taxes: 'Bases imponibles',

  company_required_fields_modal_option_field_name: 'Nombre del campo',
  company_required_fields_modal_option_field_required_status: 'Obligatorio',

  company_required_fields_modal_update_setting_success: 'Se ha actualiazdo correctamente',
  company_required_fields_modal_update_setting_error: '¡Ups! Algo ha ido mal al intentar actualizar la configuración solicitada',
  /* Create Custom Field Modal */
  company_create_transaction_field_modal_header: 'Crear campo nuevo',
  company_update_transaction_field_modal_header: 'Actualizar campo',
  company_update_transactions_transactions_affected_warning:
    'Tienes transacciones con información relativa a este campo. ¿Quieres continuar?',
  company_create_transaction_field_name: 'Nombre',
  company_create_transaction_field_name_placeholder:
    'Introduce nombre del campo',
  company_create_transaction_field_description: 'Descripción',
  company_create_transaction_field_description_placeholder:
    'Introduce descripcion para el campo',
  company_create_transaction_field_option_type:
    'Permite seleccionar más de una opción',
  company_create_transaction_field_allow_multiselect:
    'Permitir seleccionar varias',
  company_create_transaction_field_option_settings:
    'Crea las opciones de este campo',
  company_create_transaction_field_option_settings_placeholder:
    'Escribe y pulsa enter',
  company_create_transaction_field_option_tag_transaction_detail_placeholder:
    'Crear esta opción',

  company_create_transaction_field_allow_custom_options:
    'Permitir al empleado crear otras',
  company_create_transaction_field_allow_custom_options_info:
    'Permite al empleado crear nuevas opciones',
  company_create_transaction_field_budgets_include_in: 'Incluir este campo en',
  company_create_transaction_field_include_in_all_budgets:
    'Todos los presupuestos',
  company_create_transaction_field_include_in_all_budgets_explanation:
    'Incluir en todos los presupuestos actuales y futuros',
  company_create_transaction_field_include_in_selected_budgets:
    'Presupuestos seleccionados',
  company_create_transaction_field_require: 'Requerir este campo en',
  company_create_transaction_field_require_never: 'Nunca',
  company_create_transaction_field_require_always: 'Siempre',
  company_create_transaction_field_require_selected_budgets:
    'Para presupuestos seleccionados',
  company_create_transaction_field_action_create_field: 'Crear campo',
  company_create_transaction_field_action_update_field: 'Actualizar campo',
  company_create_transaction_field_options_no_options: 'Escribe y pulsa enter',
  company_create_transaction_field_select_budget: 'Selecciona presupuesto',
  company_create_transaction_field_no_budgets: 'No hay presupuestos',

  company_create_custom_field_success: 'Se ha creado el campo correctamente',
  company_update_custom_field_success: 'Se ha actualizado el campo correctamente',
  company_delete_custom_field_success: 'Se ha eliminado el campo correctamente',

  company_create_custom_field_error: 'Ha ocurrido un error creando el campo',
  company_update_custom_field_error:
    'Ha ocurrido un error actualiazando el campo',
  company_delete_custom_field_error: 'Ha ocurrido un error eliminando el campo',
  company_fetch_transaction_fields_error:
    'Ha ocurrido un error al cargar los campos',
  company_fetch_company_error: 'Ha ocurrido un error los datos de la compañía',
  company_update_company_information_success:
    'Se ha actualizado la información correctamente',
  company_update_company_information_error: '¡Ups! Algo ha ido mal al actualizar la información de la empresa',
  company_create_custom_field_include_in_transaction_type: 'Incluir este campo en',
  company_update_company_address_info: 'Vas a editar la información de envío de tarjetas de la empresa {customerName}, rellena todos los campos y pulsa Enviar.',
  company_update_company_address_warning: 'Estás a punto de modificar la dirección de envío de tarjetas para la empresa {customerName}, revisa bien la información y pulsa confirmar para guardar los cambios, o cancelar para volver.',
  company_update_company_fiscal_address_info: 'Vas a editar la dirección de facturación (domicilio social) de la empresa {customerName}, rellena todos los campos y pulsa enviar.',
  company_update_company_fiscal_address_warning: 'Estás a punto de modificar la dirección de facturación (domicilio social) para la empresa {customerName}, revisa bien la información y pulsa confirmar para guardar los cambios, o cancelar para volver.',
  customer_show_edit_address_modal_action: 'Dirección de envío de tarjetas',
  customer_show_edit_fiscal_address_modal_action: 'Dirección de facturación de la empresa',
  customer_edit_address_modal_header: 'Editar dirección de envío de tarjetas',
  customer_edit_address_confirm: 'Editar dirección',
  customer_edit_fiscal_address_modal_header: 'Editar dirección de facturación de la empresa',

  /* - Payment Methods modal - */
  company_payment_methods_settings_modal_title: 'Métodos de pago',
  company_payment_methods_settings_description: 'Puedes configurar los métodos de pago que admite tu empresa además de la tarjeta Fuell. Se pueden definir los tipos de gasto en los que se pueden utilizar, los empleados que tienen el método activo y si permiten reembolso.',
  company_payment_methods_table_payment_method_header: 'Método de pago',
  company_payment_methods_table_expense_type_header: 'Tipo de gasto',
  company_payment_methods_table_users_header: 'Usuarios',
  company_payment_methods_table_repayable_header: 'Reembolsable',
  company_payment_methods_table_bydefault_header: 'Por defecto',
  company_payment_methods_table_repayable_tooltip: 'Los gastos marcados con esta opción aparecerán como reembolsables en el archivo de exportación.',
  company_payment_methods_table_byDefault_tooltip: 'Se asignarán por defecto los métodos de pago que selecciones a los nuevos usuarios.',
  company_payment_methods_table_byDefault_disabled_tooltip: 'Si el método de pago se aplica a Todos se asignará por defecto a los nuevos usuarios.',
  company_payment_methods_table_payment_method_name_placeholder: 'Nombre',
  company_payment_methods_table_expense_type_placeholder: 'Tipo de gasto',
  company_payment_methods_table_users_placeholder: 'Usuarios',
  company_payment_methods_add_payment_method_action: '+ Añadir método de pago',
  company_payment_methods_modal_confirm_delete: 'Borrar método de pago',
  company_payment_methods_modal_confirm_delete_warning: '¿Estás seguro de borrar el método de pago? Esta acción no se puede deshacer',
  company_payment_methods_modal_update_error: '¡Ups! Algo ha ido mal al intentar actualizar el método de pago',
  company_payment_methods_modal_create_error: '¡Ups! Algo ha ido mal al intentar crear el método de pago',
  company_payment_methods_modal_delete_error: '¡Ups! Algo ha ido mal al intentar borrar el método de pago',
  company_payment_methods_modal_get_payment_methods_error: '¡Ups! Algo ha ido mal al intentar obtener los métodos de pago',

  /* - Card Schedule Modal - */
  company_cards_schedule_settings_modal_title: 'Definir horarios de uso de tarjeta',
  company_cards_schedule_settings_description: 'Puedes configurar un horario de uso de las tarjetas según el presupuesto que tengan asignadas. Si un presupuesto no tiene un horario asignado, las tarjetas podrán hacer gasto cualquier día a cualquier hora.',
  company_cards_schedule_table_name_header: 'Nombre',
  company_cards_schedule_table_days_header: 'Días',
  company_cards_schedule_table_hours_header: 'Horas',
  company_cards_schedule_table_budgets_header: 'Presupuestos',
  company_cards_schedule_table_card_schedule_name_placeholder: 'Nombre',
  company_cards_schedule_table_budgets_placeholder: 'Presupuestos',
  company_cards_schedule_add_card_schedule_action: '+ Añadir horario',
  company_cards_schedule_settings_default_title: 'Horario por defecto para nuevos presupuestos',
  company_cards_schedule_settings_default_description: 'Puedes elegir un horario para que se aplique automáticamente a los nuevos presupuestos que se creen en la empresa.',
  company_cards_schedule_settings_default_label: 'Horario por defecto',
  company_cards_schedule_modal_overwrite_budget: 'Cambio de horario asignado',
  company_cards_schedule_modal_overwrite_budget_single: 'El presupuesto que has seleccionado tiene otro horario asignado. ¿Quieres asignarle este nuevo horario?',
  company_cards_schedule_modal_overwrite_budget_multiple: 'Varios presupuestos que has seleccionado tienen otro horario asignado. ¿Quieres asignarles este nuevo horario?',
  company_cards_schedule_modal_confirm_delete: 'Borrar horario de tarjetas',
  company_cards_schedule_modal_confirm_delete_warning: '¿Estás seguro de borrar el horario? Esta acción no se puede deshacer',
  /* - Expenses Fields  - */

  expense_fields_creation_subtitle:
    'En esta sección podrás configurar aspectos concretos de la creación de gastos, como las categorías para los kilometrajes',
  expense_fields_mileage_categories: 'Categorías de kilometraje',
  expense_fields_diet_categories: 'Categorías de dietas',
  company_expense_fields_mileage_category_header: 'Nombre',
  company_expense_fields_mileage_category_rate: 'Coste por kilómetro',

  expense_fields_new_mileage_category: 'Añadir categoría de kilometraje',
  expense_fetch_mileage_categories_error:
    '¡Ups! Algo ha ido mal al intentar obtener las categorías de kilometraje',
  company_update_mileage_category_success:
    'Se ha actualizado la categoría de kilometraje correctamente',
  company_update_mileage_category_error:
    '¡Ups! Algo ha ido mal al intentar  actualizar la categoría de kilometraje',
  company_create_mileage_category_success:
    'Se ha creado la categoría de kilometraje correctamente',
  company_create_mileage_category_error:
    '¡Ups! Algo ha ido mal al intentar crear la categoría de kilometraje',
  company_delete_mileage_category_success:
    'Se ha eliminado la categoría de kilometraje correctamente',
  company_delete_mileage_category_error:
    '¡Ups! Algo ha ido mal al intentar crear la categoría de kilometraje',

  /* - Create mileage and diet categories  modal - */
  company_create_mileage_category_modal_header:
    'Crear categoría de kilometraje',
  company_edit_mileage_category_modal_header: 'Editar categoría de kilometraje',
  company_create_mileage_category_modal_confirm: 'Crear categoría',
  company_edit_mileage_category_modal_confirm: 'Guardar cambios',
  company_edit_diet_category_modal_header: 'Editar categoría de dieta',
  company_create_diet_category_modal_header: 'Crear categoría de dieta',
  company_edit_diet_category_modal_confirm: 'Guardar cambios',
  company_create_diet_category_modal_confirm: 'Crear categoría',
  expense_fields_new_diet_category: 'Crear categoría de dieta',

  company_update_diet_category_success:
    'Se ha actualizado la categoría de dieta correctamente',
  company_update_diet_category_error:
    '¡Ups! Algo ha ido mal al intentar actualizar la categoría de dieta',
  company_create_diet_category_success:
    'Se ha creado la categoría de dieta correctamente',
  company_create_diet_category_error:
    '¡Ups! Algo ha ido mal al intentar crear la categoría de dieta',
  company_delete_diet_category_success:
    'Se ha borrado la categoría de dieta correctamente',
  company_delete_diet_category_error:
    '¡Ups! Algo ha ido mal al intentar eliminar la categoría de dieta',
  expense_fetch_diet_categories_error:
    '¡Ups! Algo ha ido mal al intentar obtener el listado de categorías de dieta',

  company_create_mileage_category_name: 'Nombre',
  company_create_mileage_category_rate: 'Coste por kilómetro (€/Km)',
  company_create_diet_category_amount: 'Cantidad',

  /* - Funnel Aproval options */

  company_funnel_aproval_flow_section_header: 'Flujos de aprobación',
  company_funnel_aproval_flow_create_flow: 'Crear flujo de aprobación',
  company_funnel_aproval_flow_info: 'Crea y edita flujos de aprobación con varios niveles de revisión. Los presupuestos sin flujo multinivel asignado funcionarán con la aprobación simple por defecto.',

  company_funnel_aproval_flow_table_column_name: 'Nombre',
  company_funnel_aproval_flow_table_column_aproval_levels: 'Niveles de aprobación',
  company_funnel_aproval_flow_table_column_budgets: 'Presupuestos',

  /* Create funnel flow modal */
  company_create_funnel_flow_modal_header: 'Crear flujo de aprobación multinivel',
  company_edit_funnel_flow_modal_header: 'Editar flujo de aprobación multinivel',
  company_create_funnel_flow_modal_form_name: 'Nombre',
  company_create_funnel_flow_modal_form_name_placeholder: 'Nombre del flujo de aprobación',
  company_create_funnel_flow_modal_form_include_flow_in: 'Incluir el flujo de aprobación en',
  company_create_funnel_flow_modal_form_include_flow_in_selected_budgets_option: 'Presupuestos seleccionados',
  company_create_funnel_flow_modal_form_include_flow_in_selected_budgets_option_name: 'Presupuestos',
  company_create_funnel_flow_modal_form_include_flow_in_selected_budgets_option_name_placeholder: 'Buscar...',
  company_create_funnel_flow_modal_form_include_flow_in_selected_budgets_option_all_budgets_option: 'Todos',
  company_create_funnel_flow_modal_form_mark_as_default_label: 'Utilizar como flujo de aprobación por defecto',
  company_create_funnel_flow_modal_form_mark_as_default_info_tooltip: 'Se asignará por defecto este flujo de aprobación a los nuevos presupuestos que se creen en la plataforma.',
  company_create_funnel_flow_modal_form_confirm_budget_change_header: 'Reasignar flujo de aprobación',
  company_create_funnel_flow_modal_form_confirm_budget_change_warning: 'Este presupuesto tiene otro flujo de aprobación asignado. ¿Estás seguro de querer reasignarlo?',
  company_create_funnel_flow_modal_form_confirm_budget_change_action_confirm: 'Reasignar',

  company_create_funnel_flow_modal_form_confirm_default_flow_change_header: 'Flujo de aprobación por defecto',
  company_create_funnel_flow_modal_form_confirm_default_flow_warning: 'Hay otro flujo de aprobación definido por defecto. ¿Estás seguro de querer seleccionar este como flujo por defecto?',

  company_create_funnel_flow_modal_form_flow_steps: 'Pasos del flujo',
  company_create_funnel_flow_modal_form_flow_steps_hint: 'Indica los pasos que deberá pasar un gasto en el flujo de aprobación así como los roles / personas que van a revisar el gasto en cada paso.',
  company_create_funnel_flow_modal_form_flow_steps_add_step: '+ Añadir paso',
  company_create_funnel_flow_modal_form_flow_steps_add_step_name: 'Nombre',
  company_create_funnel_flow_modal_form_flow_steps_add_step_name_placeholder: 'Nombre del paso',
  company_create_funnel_flow_modal_form_flow_steps_add_step_reviewers: 'Revisore(es)',
  company_create_funnel_flow_modal_form_flow_steps_add_step_reviewers_placeholder: 'Buscar...',

  company_create_funnel_flow_modal_form_create_flow: 'Crear flujo de revisión',
  company_create_funnel_flow_modal_form_edit_flow: 'Guardar cambios',
  company_fetch_review_flows_error: '¡Ups! Algo ha ido mal al intentar obtener el listado de flujos de revisón',
  company_fetch_review_flow_error: '¡Ups! Algo ha ido mal al intentar obtener este flujo de revisión',
  company_create_review_flow_success: 'Se ha creado el flujo de revisión correctamente',
  company_update_review_flow_success: 'Se ha actualizado el flujo de revisión correctamente',
  company_create_review_flow_error: '¡Ups! Algo ha ido mal al intentar crear el flujo de revisión',
  company_update_review_flow_error: '¡Ups! Algo ha ido mal al intentar actualizar el flujo de revisión',
  company_delete_review_flow_success: 'Se ha borrado el flujo de revisión correctamente',
  company_delete_review_flow_error: '¡Ups! Algo ha ido mal al intentar borrar este flujo',

  /* Integrations */
  company_integrations_settings_information:
    'Encontrarás aquí las configuraciones necesarias para integrarnos con tus plataformas (ERPs) externas. Si no encuentras tu plataforma, nos puedes recomendar integraciones en el apartado de sugerencias en el listado.',
  company_integrations_suggest_integration: '¿Sugerencias?',
  company_integrations_suggest_integration_comment:
    '¡Recomiendanos una integración!',
  company_intragrations_settings_config_updated_success:
    'Se ha actualizado la configuración correctamente',

  /* -- Integrations: Holded */
  company_integrations_settings_holded_payment_account_number:
    'Número de cuenta de pago',

  /* Export Settings */
  company_export_settings_information: 'En esta sección puede configurar todo lo necesario para exportar la información de las transacciones y los reembolsos a su software de contabilidad.',
  company_export_settings_field_mapping_name: 'Nombre',
  company_export_settings_field_mapping_author: 'Autor',
  company_export_settings_field_mapping_used: 'Usado en',
  company_export_settings_file_format_name: 'Nombre',
  company_export_settings_file_format_author: 'Autor',
  company_export_settings_file_format_format: 'Formato',
  company_export_settings_file_format_used: 'Usado en',
  company_export_settings_file_formats: 'Exportar archivos de formato',
  company_export_settings_new_format: 'Crear nuevo formato',
  company_export_settings_field_mapping: 'Mapeo de campos',
  company_export_settings_new_mapping: 'Crear nuevo mapeo',
  company_export_settings_create_field_mapping_name: 'Nombre',
  company_export_settings_create_field_mapping_correspondence: 'Correspondencia entre impuestos',
  company_export_settings_create_field_mapping_correspondence_subtitle: 'Aquí puede modificar los valores que se utilizarán para especificar los impuestos en la exportación. Recuerde. Si no lo modifica, se exportará el valor de Fuell',
  company_export_settings_create_field_mapping_region: 'Región',
  company_export_settings_create_field_mapping_fuell: 'En fuell',
  company_export_settings_create_field_mapping_export: 'En la exportación',
  company_export_settings_create_field_mapping_category: 'Categoría',
  company_export_settings_edit_field_mapping_modal_header: 'Editar mapeo',
  company_export_settings_create_field_mapping_modal_header: 'Nuevo mapeo',
  company_export_settings_edit_field_mapping_modal_confirm: 'Guardar',
  company_export_settings_create_field_mapping_modal_confirm: 'Guardar',
  company_export_settings_create_file_format_format: 'Formato del archivo',
  company_export_settings_create_file_format_csv: 'CSV (Comma Separated Values)',
  company_export_settings_create_file_format_xlsx: 'XLSX (Excel)',
  export_exportation_flow_include_tickets: 'Incluir tickets',
  company_export_settings_create_file_format_columns: 'Columnas del archivo',
  company_export_settings_create_file_format_columns_subtitle: 'Indica las columnas que quieres que tenga el fichero final, indicando los datos que necesitas que vayan en cada una de ellas.',
  company_export_settings_create_file_format_name: 'Nombre',
  company_export_settings_create_file_format_data: 'Dato',
  company_export_settings_create_file_format_date_format: 'Formato de fecha',
  company_export_settings_create_file_format_amount_format: 'Formato de cantidad',
  company_export_settings_create_file_format_delete: 'Eliminar dato',
  company_export_settings_create_file_format_tag: 'Escribe y pulsa enter',
  company_export_settings_create_file_format_example: 'Ejemplo',
  company_export_settings_create_file_format_add_column: '+ Añadir columna',
  company_export_settings_edit_file_format_modal_header: 'Editar formato',
  company_export_settings_create_file_format_modal_header: 'Nuevo formato',
  company_export_settings_edit_file_format_modal_confirm: 'Guardar',
  company_export_settings_create_file_format_modal_confirm: 'Guardar',

  export_fetch_export_fields_error: '¡Ups! Algo ha ido mal al intentar obtener los mapeos de campos',
  export_fetch_file_format_error: '¡Ups! Algo ha ido mal al intentar obtener el formato de archivo',
  export_fetch_file_formats_error: '¡Ups! Algo ha ido mal al intentar obtener los formatos de archivo',
  export_update_file_format_error: '¡Ups! Algo ha ido mal al actualizar el formato de archivo',
  export_create_file_format_error: '¡Ups! Algo ha ido mal al crear el formato de archivo',
  export_delete_file_format_error: '¡Ups! Algo ha ido mal al eliminar el formato de archivo',
  expense_fetch_fields_mapping_error: '¡Ups! Algo ha ido mal al intentar obtener los mapeos de campos',
  expense_update_fields_mapping_error: '¡Ups! Algo ha ido mal al actualizar los mapeos de campos',
  expense_create_fields_mapping_error: '¡Ups! Algo ha ido mal al crear los mapeos de campos',
  expense_delete_fields_mapping_error: '¡Ups! Algo ha ido mal al eliminar los mapeos de campos',
  export_update_file_format_success: 'Se ha actualizado correctamente el formato de archivo',
  export_create_file_format_success: 'Se ha creado correctamente el formato de archivo',
  export_delete_file_format_success: 'Se ha eliminado correctamente el formato de archivo',
  expense_update_fields_mapping_success: 'Se ha actualizado correctamente el mapeo de campo',
  expense_create_fields_mapping_success: 'Se ha creado correctamente el mapeo de campo',
  expense_delete_fields_mapping_success: 'Se ha eliminado correctamente el mapeo de campo',
  export_fetch_exportation_flows_error: '¡Ups! Algo ha ido mal al intentar obtener los flujos de exportación',
  export_fetch_exportation_flow_error: '¡Ups! Algo ha ido mal al intentar obtener el flujo de exportación',
  export_update_exportation_flow_error: '¡Ups! Algo ha ido mal al actualizar el flujo de exportación',
  export_create_exportation_flow_error: '¡Ups! Algo ha ido mal al crear el flujo de exportación',
  export_delete_exportation_flow_error: '¡Ups! Algo ha ido mal al eliminar el flujo de exportación',
  export_create_export_history_error: '¡Ups! Algo ha ido mal al crear la exportación',
  export_update_exportation_flow_success: 'Se ha actualizado correctamente el flujo de exportación',
  export_create_exportation_flow_success: 'Se ha creado correctamente el flujo de exportación',
  export_delete_exportation_flow_success: 'Se ha eliminado correctamente el flujo de exportación',
  export_create_export_history_success: 'Se ha creado correctamente la exportación',
  export_count_used_more: ' y + { quantity } más',

  /* ------------------- */

  /* Benefits - Flexible Remuneration section */
  benefits_users_table_header_employee: 'Nombre',
  benefits_users_table_header_meals_activated: 'Comida activada',
  benefit_users_table_header_limit: 'Límite de comida',
  benefits_users_table_header_limit_meal_accumulative: 'Saldo comida',
  benefit_users_table_header_limit_monthly_assigned: 'Asignación mensual',
  benefits_users_table_header_spent_vs_available: '% Gastado vs disponible',
  benefits_users_table_header_transport_activated: 'Transporte activado',

  benefit_users_table_header_transport_limit: 'Límite de transporte',
  benefits_users_table_header_limit_transport_accumulative: 'Saldo transportes',
  benefits_users_table_header_nursery_assignation: 'Guarderías: asignación',
  benefits_tab_flex_retribution: 'Plan de retribución flexible',
  benefits_tab_social_benefits: 'Beneficios sociales (recurrente)',
  benefits_tab_flex_transactions: 'Transacciones',
  benefits_export: 'Exportar',
  benefits_fetch_flex_budgets_error:
    '¡Ups! Algo ha ido mal al intentar obtener las opciones de retribucion flexible del usuario',
  benefits_max_meal_allowed_surpased:
    'Sólo puedes asignar cantidades menores o iguales al límite exento asignado al usuario',
  benefits_transactions_fetch_transactions_error:
    '¡Ups! Algo ha ido mal al intentar obtener las transacciones',
  benefits_export_benefits_error:
    '¡Ups! Algo ha ido mal al exportar las transacciones',

  benefits_export_benefits_select_period: 'Selecciona periodo para exportar',
  benefits_export_select_period: 'Periodo',
  benefits_fetch_export_periods_error:
    '¡Ups! Algo ha ido mal al intentar obtener los periodos de exportación',
  /* Benefits configuration */
  office_feature_not_available:
    'Esa funcionalidad no está activa para la oficina actual',
  benefits_configuration: 'Configurar',
  benefits_configure_benefits_header: 'Configuración de beneficios',
  benefits_office_setting_update_success:
    'Se ha actualizado la configuración correctamente',
  benefits_office_setting_update_error:
    '¡Ups! Hemos tenido un problema al intentar actualizar la configuración',
  benefits_toggle_all_users_features_status_success:
    'Hemos cambiado el estado de todos los usuarios correctamente',
  benefits_toggle_all_users_features_status_error:
    '¡Ups! Algo ha ido mal al intentar cambiar el estado de los beneficios de los empleados',
  benefits_closure_date_invalid_value_error: 'Introduce un día válido',
  benefits_closure_data_value_not_in_range_error:
    'El día que has seleccionado es inválido, introduce un día entre 1 y 31',
  benefits_closure_date_set_success:
    'Se ha establecido el día de cierre correctamente',
  benefits_set_closure_date_error:
    '¡Ups! Ha ocurrido un error al intentar indicar el día de cierre',
  benefits_configuration_settings_accumulative_benefits:
    'Retribución flexible acumulada',
  benefits_configuration_settings_activate_accumulative_benefits:
    'Activar retribución flexible acumulada para los usuarios',
  benefits_configuration_settings_accumulative_benefits_explanation:
    'Si se activa, el dinero que no gaste el empleado en el mes actual, se sumará al saldo del mes siguiente. Escríbenos a {support} para activar esta opción',
  benefits_configuration_benefits_closure_date: 'Día del mes',
  benefits_budget_benefit_reset_warning:
    'Indica el último día del mes antes de que se reinicien los beneficios',
  benefits_configuration_setting_activate_on_all_users:
    'Activar para todos los usuarios',
  benefits_configuration_configure_features_for_all_users_warning:
    'Solo se activará para empleados que tengan asignado el salario bruto anual, ya que es necesario para el cálculo del máximo legal. Puedes indicar el salario bruto anual en la sección de usuarios. Al activar para todos asignaremos una aproximación al máximo legal que le corresponda al usuario.',
  benefits_configuration_setting_personalize_time_restrictions:
    'Restringir horario',
  benefits_confirm_ret_flex_deactivation_with_accumulative_benefits:
    'Desactivar retribución flexible acumulada para este empleado',
  benefits_confirm_acumulation_removal_warning:
    'Este empleado tiene {balance} en {activityGroup}, al desactivar no podrá usarlos. En vez de desactivarlo, puedes establecer 0€ a partir de ahora, de forma que pueda utilizar los {balance} restantes pero no se añada nuevo saldo a su cuenta cada mes, aún así ¿quieres desactivar?',
  benefits_confirm_acumulation_setting_removal_office_warning:
    'Es posible que tengas empleados con saldo acumulado y al desactivar no podrán usarlo. En lugar de desactivar, puedes establecer a 0 € la asignación mensual de forma que puedan utilizar el saldo restante, pero no se añadirá nuevo saldo a su cuenta cada mes, aún así ¿quieres desactivar?',
  benefits_confirm_acumulation_removal_action_confirm: 'Si, quiero desactivar',
  benefits_confirm_subvention_deactivation_with_accumulative_subvention:
    'Desactivar subvención acumulada para este empleado',
  benefits_confirm_acumulation_remove_warning:
    'Éste empleado tiene fondos en alguna de las subvenciones activas, al desactivar, no podrá usarlo. En vez de desactivarlo, puedes establecer 0€ a partir de ahora, de forma que pueda seguir utilizando los fondos asignados, pero no se añada nuevo saldo a su cuenta cada mes, aún así, ¿quieres desactivar?',
  benefits_configuration_activate_feature:
    'Permitir hacer solicitud a todos los usuarios',

  benefits_configuration_activate_warning__FLEXIBLE_REMUNERATION_NURSERY:
    'Activando esta opción los empleados podrán realizar una solicitud de retribución flexible de guarderías a través de un formulario que les será enviado por Fuell. Una vez el usuario haga la solicitud, te lo notificaremos por email para que puedas aceptarlas o denegarlas.',
  benefits_configuration_activate_warning__FLEXIBLE_REMUNERATION_INSURANCE:
    'Activando esta opción los empleados podrán realizar una solicitud de retribución flexible de seguros a través de un formulario que les será enviado por Fuell. Una vez el usuario haga la solicitud, te lo notificaremos por email para que puedas aceptarlas o denegarlas.',
  benefits_configuration_activate_warning__FLEXIBLE_REMUNERATION_EDUCATION:
    'Activando esta opción los empleados podrán realizar una solicitud de retribución flexible de formación a través de un formulario que les será enviado por Fuell. Una vez el usuario haga la solicitud, te lo notificaremos por email para que puedas aceptarlas o denegarlas.',

  snackbars_insurance_policy_holders_warning:
    'Debes indicar algún titular de seguros para poder modificar la asignación',

  /* - Benefits time restrictions configuration - */
  benefits_configure_time_restrictions: 'Configurar restricciones horarias',
  benefits_header_time_restrictions: 'Restricciones horarias de uso',
  benefits_configuration_settings_time_restrictions_from_label:
    'Hora de comienzo de uso',
  benefits_configuration_settings_time_restrictions_to_label:
    'Hora de fin de uso',
  benefits_time_restrictions_configuration_modal:
    'Configurar restricciones horarias',
  benefits_configuration_settings_time_restrictions:
    'Configura las restricciones horarias para los usuarios',
  benefits_configurations_settings_time_restrictions_warning:
    'Define cuándo podrán los usuarios hacer uso de sus tarjetas. Fuera de esas restricciones temporales no podrán usarse las tarjetas para pagar ni comida ni transporte (independientemente de que sea en concepto de retribución flexible o beneficio social). El Real Decreto 439/2007 indica que la prestación del servicio (de comidas) debe tener lugar durante días hábiles para el empleado o trabajador.',

  benefits_configurations_time_restrictions_weekdays:
    'Días en los que se pueden usar',
  benefits_configurations_time_restrictions_restricted_time:
    'Horas en las que se pueden usar',
  benefits_configuration_time_restrictions_success:
    'Se han actualizado las restricciones horarias correctamente',
  benefits_configuration_time_restrictions_error:
    '¡Ups! Hemos tenido un problema al intentar actualizar las restricciones horarias:',
  benefits_configuration_time_from_after_to:
    'La hora de comienzo no puede ser posterior a la de fin de uso',
  benefits_configuration_time_to_before_from:
    'La hora de fin de uso no puede ser anterior a la de comienzo de uso',
  /* Flexible remuneration types */
  benefits_ret_flex_name__FLEXIBLE_REMUNERATION_MEAL:
    'Retribución flexible de comidas',
  benefits_ret_flex_name__FLEXIBLE_REMUNERATION_TRANSPORT:
    'Retribución flexible de transporte',
  benefits_ret_flex_name__FLEXIBLE_REMUNERATION_NURSERY:
    'Retribución flexible de guarderías',

  benefits_ret_flex_name__FLEXIBLE_REMUNERATION_EDUCATION:
    'Retribución flexible de formación',
  benefits_ret_flex_name__FLEXIBLE_REMUNERATION_INSURANCE:
    'Retribución flexible de seguros',

  benefits_configuration_closure_date_note: 'Nota: ',
  benefits_configuration_closure_date_last_closure:
    'el último cierre se ha realizado el día {lastClosureDate}, ',
  benefits_configuration_closure_date_next_closure:
    'el próximo cierre se realizará el día {nextClosureDate}.',
  benefits_table_header_current_month_fallback: 'Mes en curso',

  /* - Benefits Columns - */
  benefits_users_table_header_subvention_status: 'Beneficio social activado',

  benefits_users_table_header_meals_current_month: 'Comidas: {currentMonth}',
  benefits_users_table_header_meals_next_months: 'Comidas: Meses siguientes',
  benefits_users_table_header_transport_current_month:
    'Transporte: {currentMonth}',
  benefits_users_table_header_transport_next_months:
    'Transporte: meses siguientes',
  benefits_users_table_header_nursery_status: 'Guardería activada',
  benefits_users_table_header_insurance_status: 'Seguros activado',
  benefits_users_table_header_insurance_assignation: 'Seguros: asignación',
  benefits_users_table_header_insurance_policy_holders: 'Seguros: titulares',
  benefits_users_table_header_insurance_disabled_policy_holders:
    'Seguros: titulares con minusvalía',
  benefits_users_table_header_insurance_education_status: 'Formación activada',
  benefits_users_table_header_insurance_education_assignation:
    'Formación: asignación',

  export_fields_InvoiceNumberLabel: 'Nº factura',
  export_fields_expenseDateLabel: 'Fecha de gasto',
  export_fields_expenseHourLabel: 'Hora de gasto',
  export_fields_balanceLabel: 'Balance',
  export_fields_currencyBalanceLabel: 'Moneda',
  export_fields_amountSettledLabel: 'Cantidad pagada',
  export_fields_currencySettledLabel: 'Moneda original',
  export_fields_amountApprovedLabel: 'Cantidad aprobada',
  export_fields_currencyApprovedLabel: 'Moneda aprobada',
  export_fields_merchantNameLabel: 'Comercio',
  export_fields_businessNameNameLabel: 'Empresa',
  export_fields_merchantIdLabel: 'Id Comercio',
  export_fields_merchantAddressLabel: 'Dirección comercio',
  export_fields_merchantZipCodeLabel: 'Código postal comercio',
  export_fields_merchantProvinceLabel: 'Provincia comercio',
  export_fields_merchantRegionLabel: 'Región comercio',
  export_fields_merchantCountryLabel: 'País comercio',
  export_fields_taxationCountryLabel: 'País del IVA',
  export_fields_employeeNameLabel: 'Nombre empleado',
  export_fields_originalCategoryLabel: 'Categoría',
  export_fields_subCategoryLabel: 'Subcategoria',
  export_fields_codeCategoryLabel: 'Código categoria',
  export_fields_noteLabel: 'Nota',
  export_fields_reviewStatusLabel: 'Revisado',
  export_fields_mediaLabel: 'Media',
  export_fields_originalTaxLabel: 'Tipo de impuesto',
  export_fields_netAmountLabel: 'Base imponible',
  export_fields_taxAmountLabel: 'Cuantía impuesto',
  export_fields_grossAmountLabel: 'Importe bruto',
  export_fields_budgetNameLabel: 'Nombre presupuesto',
  export_fields_paymentMethodCodeLabel: 'Método de pago',
  export_fields_refundableLabel: 'Reembolsable',
  export_fields_isReceiptLabel: '¿Es recibo?',
  export_fields_transactionStatusLabel: 'Estado',
  export_fields_receiptTypeLabel: 'Recibo o factura',
  export_fields_expenseCreatedAtLabel: 'Fecha creación gasto',
  export_fields_receiptNumberLabel: 'Número de recibo',
  export_fields_employeeIdentifierLabel: 'Identificador empleado',
  export_fields_employeeExpenseCenterLabel: 'Centro de gasto',
  export_fields_transactionCreatedAtLabel: 'Fecha creación transacción',
  export_fields_transactionReviewedAtLabel: 'Fecha revisión',
  export_fields_creditAmountLabel: 'Debe',
  export_fields_debitAmountLabel: 'Haber',
  export_fields_IVALabel: 'IVA',
  export_fields_grossAmountEuroLabel: 'Importe bruto €',
  export_fields_confirmationDateLabel: 'Fecha de confirmación',
  export_fields_mediaLinkLabel: 'Enlace media',
  export_fields_transactionIdLabel: 'Identificador gasto',
  export_fields_taxType1Label: 'Tipo de impuesto 1',
  export_fields_taxBase1Label: 'Base imponible 1',
  export_fields_vat1Label: 'Cuantía impuesto 1',
  export_fields_taxType2Label: 'Tipo de impuesto 2',
  export_fields_taxBase2Label: 'Base imponible 2',
  export_fields_vat2Label: 'Cuantía impuesto 2',
  export_fields_taxType3Label: 'Tipo de impuesto 3',
  export_fields_taxBase3Label: 'Base imponible 3',
  export_fields_vat3Label: 'Cuantía impuesto 3',
  export_fields_taxType4Label: 'Tipo de impuesto 4',
  export_fields_taxBase4Label: 'Base imponible 4',
  export_fields_vat4Label: 'Cuantía impuesto 4',
  export_fields_taxType5Label: 'Tipo de impuesto 5',
  export_fields_taxBase5Label: 'Base imponible 5',
  export_fields_vat5Label: 'Cuantía impuesto 5',
  export_fields_taxType6Label: 'Tipo de impuesto 6',
  export_fields_taxBase6Label: 'Base imponible 6',
  export_fields_vat6Label: 'Cuantía impuesto 6',
  export_fields_budgetField1Label: 'Campo presupuesto 1',
  export_fields_budgetField2Label: 'Campo presupuesto 2',
  export_fields_budgetField3Label: 'Campo presupuesto 3',
  export_fields_vatTypeCodeLabel: 'Código de impuesto',

  export_fields_userDocumentLabel: 'Identificación usuario (DNI)',

  /* EXPORT FLOW */
  exports_create_export_flow_title: 'Aún no tienes ningún flujo de exportación',
  exports_create_export_flow_subtitle: 'Los flujos son la forma de configurar una exportación para que te sea más fácil hacerla de forma recurrente. Vamos a crear el primero. No te preocupes, afortunadamente es muy sencillo',
  exports_create_export_flow_button: 'Crear exportación',
  export_exportation_flow_name: 'Nombre',
  export_exportation_flow_exportation_system: 'Sistema de exportación',
  export_exportation_flow_exportation_system_subtitle: 'Elige dónde acabarán los datos de exportación',
  export_exportation_flow_erp: 'ERP conectado',
  export_exportation_flow_erp_placeholder: 'ERP',
  export_exportation_flow_destination_file: 'Archivo de destino',
  export_exportation_flow_field_mapping: 'Asignación de campos',
  export_exportation_flow_field_mapping_subtitle: '¿Qué asignación de campos se utilizará?',
  export_exportation_flow_field_mapping_placeholder: 'Seleccionar de la lista',
  export_exportation_flow_field_mapping_empty: 'No utilizar mapeo de campos',
  export_exportation_flow_historical: 'Histórico de exportaciones',
  export_exportation_flow_historical_description: 'Mantener histórico de exportaciones',
  export_exportation_flow_historical_info: 'Marcando esta casilla no se te mostrarán los gastos que se hayan exportado con anterioridad',
  export_exportation_flow_entities_to_export: 'Entidades a exportar',
  export_exportation_flow_entities_to_export_NORMAL: 'Transacciones',
  export_exportation_flow_entities_to_export_EXPENSE: 'Reembolsos',
  export_exportation_flow_initial_filters: 'Filtros iniciales',
  export_exportation_flow_initial_filters_subtitle: '¿Desea aplicar un filtro por defecto al acceder al flujo de exportación?',
  export_exportation_flow_initial_filters_ALL: 'Todos',
  export_exportation_flow_initial_filters_DENIED: 'Denegado',
  export_exportation_flow_initial_filters_COMPLETED: 'Completado',
  export_exportation_flow_initial_filters_APPROVED: 'Aprobado',
  export_exportation_flow_initial_filters_PERSONAL_EXPENSES: 'Gastos personales',
  export_exportation_flow_initial_filters_MISSING_INFO: 'Falta información',
  export_exportation_flow_initial_filters_SEND_FOR_REVIEW: 'En revisión',
  export_exportation_flow_initial_filters_DENIED_PERSONAL_EXPENSES: 'Rechazado/Gasto personal',
  export_exportation_flow_date: 'Fecha',
  export_exportation_flow_clear_dates: 'Limpiar selección de fechas',
  export_exportation_flow_user_search: 'Seleccione uno o más de la lista',
  export_exportation_flow_budget_search: 'Seleccione uno o más de la lista',
  export_exportation_flow_file_format: 'Plantilla',
  export_edit_exportation_flow_modal_header: 'Modificar flujo de exportación',
  export_create_exportation_flow_modal_header: 'Nuevo flujo de exportación',
  export_edit_exportation_flow_modal_confirm: 'Guardar',
  export_create_exportation_flow_modal_confirm: 'Guardar',
  export_exportation_flow_tabs_all: 'Todos',
  export_exportation_flow_tabs_transactions: 'Transacciones',
  export_exportation_flow_tabs_expenses: 'Reembolsos',
  export_exportation_flow_using: 'Exportar utilizando',
  export_exportation_flow_using_placeholder: 'Seleccionar flujo de exportación',
  export_flow_create_export_flow: '+ Nuevo flujo de exportación',
  export_flow_modify: 'Modificar',
  export_flow_export: 'Exportar',
  export_exportation_flow_exported: 'Ir a Exportados',
  export_flow_exported_date: 'Fecha',
  export_flow_exported_exportation: 'Ir a Exportación',
  export_flow_exported_file: 'Fichero',
  export_flow_exported_filters: 'Filtros',
  export_flow_exported_format: 'Formato',
  export_flow_exported_status: 'Estado',

  export_exportation_flow_translate_filters_completed: 'Completado',
  export_exportation_flow_translate_filters_status: 'Estado: ',
  export_exportation_flow_translate_filters_status_CANCELLED: 'Cancelado ',
  export_exportation_flow_translate_filters_status_APPROVED: 'Aprobado ',
  export_exportation_flow_translate_filters_personal_expense: 'Gasto personal',
  export_exportation_flow_translate_filters_date: 'Fecha: ',
  export_exportation_flow_translate_filters_entity_NORMAL: 'Entidad: transacciones',
  export_exportation_flow_translate_filters_entity_EXPENSE: 'Entidad: reembolsos',
  export_exportation_flow_translate_filters_entity_ALL: 'Entidades: transacciones y reembolsos',
  export_exportation_flow_translate_filters_budget: 'Presupuesto: ',
  export_exportation_flow_translate_filters_user: 'Usuarios: ',

  /* -------------- */
  /* - MERCHANT SETTINGS - */
  merchant_settings_merchant_settings_tab: 'Comercios',
  merchant_settings_actitvy_groups_settings_tab: 'Sectores de actividad',
  merchant_settings_merchant_create_button: 'Nuevo comercio',

  /* - Merchant Settings Table - */
  merchant_merchant_name: 'Nombre a mostrar',
  merchant_merchant_social_reason: 'Razón social',
  merchant_merchant_matchers: 'Filtros',
  merchant_merchant_add_matcher: 'Añadir filtro',
  merchant_merchant_cif: ' CIF',
  merchant_merchant_identifiers: 'Identificadores internos',

  /* - Merchant details  - */
  merchants_merchant_detail_header: 'Configuración de comercio',
  merchants_fetch_merchant_error:
    '¡Ups! Hemos tenido un problema al obtener la información del comercio',
  merchants_update_logo_success:
    'Se ha actualizado el logo del comercio correctamente',
  merchants_update_logo_error:
    '¡Ups! Hemos tenido un problema al intentar actualizar el logo del comercio',
  merchants_update_merchant_success:
    'Se ha actualizado el comercio correctamente',
  merchants_update_merchant_error:
    '¡Ups! Hemos tenido un problema al intentar actualizar el comercio',
  merchants_create_merchant_success: 'Se ha creado el comercio correctamente',
  merchants_create_merchant_error:
    '¡Ups! Hemos tenido un problema al intentar crear el comercio',
  merchant_merchant_matcher_text: 'Contiene el texto',
  merchant_merchant_matcher_text_case_insensitive_info:
    'No se diferencia entre mayúsculas y minúsculas',

  /* - Activity Groups  - */
  merchants_activity_group_header_name: 'Nombre',
  merchants_fetch_activity_groups_error:
    '¡Ups! Hemos tenido un problema al obtener el listado de sectores de actividad',

  /* - Activity group detail - */
  merchants_activity_group_detail: 'Detalle sector de actividad',
  merchants_activity_group_name: 'Nombre',
  merchants_activity_group_national_codes: 'Códigos nacionales',
  merchants_activity_group_international_codes: 'Códigos internacionales',
  merchants_fetch_activity_group_error:
    '¡Ups! Hemos tenido un problema al intentar obtener el detalle de este sector de actividad',
  merchants_update_activity_group_logo_success:
    'Logo de sector de actividad actualizado correctamente',
  merchants_update_activity_group_logo_error:
    '¡Ups! Hemos tenido un problema al actualizar el logo del sector de actividad',

  /* -------------- */
  superadmin_make_admin_confirm_title: 'Esta acción no es reversible, ¿quieres continuar?',
  superadmin_make_admin_success: 'Este usuario ahora es admin',
  superadmin_make_admin_error: 'No se ha podido hacer admin a este usuario',
  superadmin_generate_otp_success:
    'Se ha enviado un One Time Password a tu teléfono, revisa tus SMS',
  superadmin_generate_otp_error:
    '¡Ups! Hemos tenido un problema al intentar generar tu one time password, vuelve a intentarlo',

  /* - GENERIC TERMS  --- */

  file_input_select_browse: 'Explorar',
  file_input_select_file: 'Seleccionar Archivos ...',
  file_input_amount_files_selected: '{amount} archivos seleccionados',
  media_viewer_fetch_resource: 'Descargar',
  media_viewer_fetching_resource: 'Descargando...',
  media_viewer_delete_resource: 'Eliminar',
  media_viewer_deleting_resource: 'Eliminando...',
  date_picker_input_placeholder: 'Selecciona un rango de fechas',
  date_picker_input_expiration_date_select_default_date: 'Sin Caducidad',
  date_picker_input_transaction_date_range_selector: 'Fechas de transacción',
  date_picker_input_from: 'Fecha inicio',
  date_picker_input_to: 'Fecha fin',
  date_picker_input_range_selector_placeholder:
    'Haz click y selecciona la fecha de inicio y final',
  date_picker_input_range_selector_range_selected:
    'Desde el {startDate} hasta el {endDate} incluído',
  date_picker_select_range_selector_range_selected: '{startDate} a {endDate}',
  date_picker_input_placeholder_mask: 'MM/DD/YYY',
  date_invalid_error: 'Introduce una fecha válida',
  date_select_this_month: 'Mes actual',
  date_select_last_month: 'Mes pasado',
  date_select_this_year: 'Este año',
  date_select_last_seven_days: 'Últimos 7 días',
  date_select_personalized_range: 'Rango personalizado',
  date_select_personalized_range_from_to: 'a',
  snackbar_launch_intercom_message: 'Pregúntanos por chat si necesitas ayuda',
  intercom_predefined_error_message:
    'Hola, he recibido el siguiente mensaje de error: " {errorMessage} ", ¿ Me podéis echar una mano ?',
  intercom_predefined_error_message_with_route:
    'Hola, he recibido el siguiente mensaje de error: " {errorMessage} " estando en esta dirección : {routerUrl} , ¿me podéis echar una mano?',
  intercom_open_conversation: 'Contactar por chat',
  intercom_import_users_message:
    'Hola, necesito ayuda para importar usuarios, ¿me podéis echar una mano?',
  intercom_reset_passcode_message:
    'Hola, necesito recuperar mi clave, ¿me podéis echar una mano?',
  intercom_message_variation_message:
    'Si necesitas ayuda, pregúntanos por chat.',
  multiselect_no_options_slot_default: 'No se han encontrado opciones',
  multiselect_no_result_slot_default:
    'No se han encontrado resultados, vuelve a probar',
  multiselect_no_users_found: 'No se han encontrado usuarios',
  multiselect_no_users: 'No hay usuarios disponibles',
  multiselect_accounting_period_not_found: 'No se ha encontrado periodo',

  multiselect_no_accounting_periods: 'No se han encontrado periodos contables',
  multiselect_payment_method_not_found: 'No se han encontrado métodos de pago',
  multiselect_no_payment_methods: 'No se han encontrado métodos de pago',
  multiselect_no_budgets_found: 'No se han encontrado presupuestos',
  multiselect_no_budgets: 'No hay presupuestos creados',
  multiselect_no_categories_found: 'No se han encontrado categorías',
  multiselect_limit_text: 'y {count} más',
  error_handler_violation_field_message: '{fieldName}',

  route_redirection_role_notification:
    'No tienes permisos para acceder a la ruta que indicaste',
  keyword_to_range: 'a',
  /* ------- */

  network_error_message:
    '¡Ups! Parece que tenemos problemas para conectar, vuelve a intentarlo en unos instantes o recarga la página',
  /* - Validation Generic Messages - */
  validations_password_mismatch: 'Las contraseñas no coinciden',

  /* - Confirm Modal Text - */
  confirm_modal_title: '¿Estás seguro?',
  confirm_modal_message: '¿Estás seguro? Esta acción no se puede deshacer',
  confirm_modal_accept_button_text: 'Sí',
  confirm_modal_dismiss_button_text: 'Cancelar',
  /* ------ */

  /* -- Card Usage Types -- */
  office_card_usage_type__OFFICE_CARDS_ALWAYS: 'Usuarios con tarjeta',
  office_card_usage_type__OFFICE_CARDS_WITHOUT: 'Usuarios sin tarjeta',
  office_card_usage_type__OFFICE_CARDS_OPTIONAL:
    'Usuarios con tarjeta opcional',
  user_card_usage_type__USER_CARDS_ALWAYS: 'Solicitar tarjeta',
  user_card_usage_type__USER_CARDS_WITHOUT: 'No solicitar tarjeta',
  user_card_usage_not_applicable: 'No aplica',
  user_card_usage_type__PHYSICAL: 'Tarjeta física',
  user_card_usage_type__VIRTUAL: 'Tarjeta virtual',

  /* -- Customer Statuses -- */
  customer_status__ACTIVE: 'Activo',
  customer_status__ARCHIVE: 'Archivado',
  customer_status__KYB_REJECTED: 'KYB rechazado',
  customer_status__ONBOARDING_PENDING: 'Pendiente de onboarding',
  customer_status__VALIDATION_PENDING: 'Pendiente de validación',

  /* -  Activity Group  - */
  activity_group__RESTAURANTS: 'comidas',
  activity_group__TRANSPORT: 'transportes',
  activity_group__INSURANCE: 'seguros',
  activity_group__NURSERY: 'guarderías',
  activity_group__EDUCATION: 'formación',
  activity_group__OTHERS: 'otros',
  /* - Country Names- */
  Spain: 'España',
  USA: 'Estados Unidos',
  country_name_Spain: 'España',
  country_name_USA: 'Estados Unidos',
  /* -  Week days  - */
  day_of_week_0: 'Lunes',
  day_of_week_1: 'Martes',
  day_of_week_2: 'Miércoles',
  day_of_week_3: 'Jueves',
  day_of_week_4: 'Viernes',
  day_of_week_5: 'Sábado',
  day_of_week_6: 'Domingo',
  day_of_week_MONDAY: 'Lunes',
  day_of_week_TUESDAY: 'Martes',
  day_of_week_WEDNESDAY: 'Miércoles',
  day_of_week_THURSDAY: 'Jueves',
  day_of_week_FRIDAY: 'Viernes',
  day_of_week_SATURDAY: 'Sábado',
  day_of_week_SUNDAY: 'Domingo',
  day_of_week_MONDAY_abbr: 'L',
  day_of_week_TUESDAY_abbr: 'M',
  day_of_week_WEDNESDAY_abbr: 'X',
  day_of_week_THURSDAY_abbr: 'J',
  day_of_week_FRIDAY_abbr: 'V',
  day_of_week_SATURDAY_abbr: 'S',
  day_of_week_SUNDAY_abbr: 'D',

  /* CURRENCIES */
  currencies_EUR: 'EUR - EU Euro',
  currencies_GBP: 'GBP - Libra esterlina',
  currencies_USD: 'USD - Dolar americano',
  currencies_ARS: 'ARS - Peso argentino',

  /* Other terms */
  EXPENSE: 'Gastos',
  REIMBURSEMENT: 'Reembolsos',
  TRANSACTION: 'Transacciones',
  DIET: 'Dieta',
  MILEAGE: 'Kilometraje',
  ALL: 'Todos',

  snackbar_sanitizing_error: 'Se ha introducido algún carácter no válido, por favor, elimínalos y vuelve a intentarlo',

  /* static pages */
  privacy_policy_page: 'https://www.getfuell.com/es/politica-privacidad',
  terms_conditions_page: 'https://www.getfuell.com/es/terminos-de-uso',
  special_conditions_services_page: 'https://www.getfuell.com/es/condiciones-particulares-servicios',
  payment_terms_page: 'https://www.getfuell.com/es/condiciones-proveedor-servicios-pago',

  // terms and conditions
  terms_conditions_title: 'Actualización de términos y condiciones',
  terms_conditions_description: 'Hemos actualizado nuestros términos y condiciones. Puedes consultar el documento completo en el siguiente {tc}.',
  terms_conditions_description_link_text: 'enlace',
  terms_conditions_label: 'He leído y acepto los nuevos Términos y condiciones',
  terms_conditions_accept: 'Confirmar',

  /* alerts modal */
  alerts_modal_title: 'Alertas',
  alerts_modal_duplicated: 'Alerta por gasto duplicado',
  alerts_modal_duplicated_description: 'Te avisaremos si detectamos algún gasto duplicado. Siempre tendrás la capacidad de revisar los gastos e ignorar la alerta.',
  alerts_modal_empty_receipt: 'Alerta por ausencia de recibo',
  alerts_modal_empty_receipt_description: 'Te avisaremos si algún gasto subido a la plataforma no tiene un recibo asociado',
  alerts_modal_out_of_office: 'Horario de gastos',
  alerts_modal_out_of_office_description: 'Define el horario en el que los empleados pueden realizar gastos de empresa. Si alguno se hace fuera de ese horario te avisaremos.',
  alerts_modal_amount_exceeded: 'Alerta por cantidad excedida',
  alerts_modal_amount_exceeded_description: 'Puedes definir unas cantidades máximas según el tipo de gasto. Si algún gasto excede esa cantidad te avisaremos.',
  alerts_modal_AMOUNT_EXCEEDED_TRANSACTION: 'Gasto',
  alerts_modal_AMOUNT_EXCEEDED_EXPENSE: 'Reembolso',
  alerts_modal_AMOUNT_EXCEEDED_MILEAGE_TYPE: 'Kilometraje',
  alerts_modal_AMOUNT_EXCEEDED_DIET: 'Dieta',
  alerts_modal_amount_distinct_ocr: 'Alerta por lectura de importe diferente',
  alerts_modal_amount_distinct_ocr_description: 'Si nuestro OCR lee un importe diferente en el recibo al valor de la transacción o al que ha introducido el empleado en el gasto, te avisaremos.',
  alerts_modal_amount_distinct_sum_taxes: 'Alerta por base imponible incorrecta',
  alerts_modal_amount_distinct_sum_taxes_description: 'Si el desglose de la base imponible junto con sus IVAs correspondientes no coincide con la cantidad pagada te avisaremos.',
  company_update_alerts_settings_error: '¡Ups! hemos tenido un problema al actualizar este tipo de alerta',

  /* Drag and drop  */
  dropzone_drag_and_drop_files_info: 'Arrastra y suelta tus tickets',
  dropzone_drag_and_drop_files_upload_count: 'Subiendo {fileCount} tickets...'

}
